<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStepNum != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 99">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                @click="handleNav(item, index)"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="toCreated(index + 1, item.id)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="secondstep" v-if="localStepNum == 0">
        <div style="margin-bottom: 10px">
          <jd-tip v-if="venderType">
            <template>
              <p v-if="jdCrm.isCrm">
                云短信CRM：订购到期时间{{ jdCrm.endTime }}（店铺需要搭配<span
                  @click="toCRM"
                  class="pointer"
                  style="color: #fe4d45"
                  >云短信CRM</span
                >使用）
              </p>
              <p v-else>
                自营店铺需要搭配云短信CRM使用，<span
                  style="color: #fe4d45; cursor: pointer"
                  @click="toCRM"
                  >前往订购>></span
                >
              </p>
            </template>
          </jd-tip>
        </div>
        <el-form
          :model="ruleForm"
          class="backgroundForm new-input-box"
          ref="ruleForm"
          label-width="135px"
        >
          <!-- <jd-title label="基本信息" type="bold"></jd-title> -->
          <informationForm 
            v-model="ruleForm" 
            needNonMember 
            :localStepNum="localStepNum" 
            :defaultActivityStartTime="ruleForm.startTime" 
            :defaultActivityEndTime="ruleForm.endTime"
            :defaultActMember.sync="actMember" 
            :disabled="activityData.isStart" 
            :plusObject.sync="ruleDto.plusObject"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            @selectPeopleSure="selectPeopleSure"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          
          <!-- <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTime"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio
              v-model="actMember"
              label="1"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="actMember"
              label="2"
              :disabled="activityData.isStart"
              >会员身份</el-radio
            >
            <el-radio
              v-model="actMember"
              label="3"
              :disabled="activityData.isStart || softType == 1"
              >指定人群
              <el-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="activityData.isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</el-button
              >
            </el-radio>

            <div v-if="actMember == '2'" style="display: flex">
              <span>会员等级：</span>
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="activityData.isStart"
                v-if="actMember == '2'"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display: flex">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="activityData.isStart"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart"
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>

          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="activityData.isStart"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="activityData.isStart"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
            ></el-checkbox>
          </el-form-item> -->

          <jd-title label="解锁奖品方式设置" type="bold"></jd-title>
          <el-form-item label="解锁方式:" required>
            <el-radio-group
              v-model="ruleForm.unlockPrizeType"
              :disabled="activityData.isStart"
              @change="unlockPrizeTypeChange"
            >
              <el-radio :label="0">符合参与对象直接解锁</el-radio>
              <el-radio :label="1">下单解锁</el-radio>
              <el-radio :label="2">完成任务解锁</el-radio>
              <el-radio :label="3">消耗积分解锁</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="订单条件:"
            required
            v-if="ruleForm.unlockPrizeType == 1"
          >
            <div class="rule_box">
              <div class="label-left">
                所下订单需满足以下条件即可解锁成功（按累计订单统计）
              </div>
              <div class="rule_box_middle">
                <el-form-item label="下单店铺:" required>
                  <orderShopCom
                    :venderIds.sync="ruleForm.venderIds"
                    :multiShopGoods.sync="multiShopGoods"
                    :sellerSkuList.sync="ruleForm.sellerSkuList"
                    :isDisabled="activityData.isStart"
                  />
                </el-form-item>
                <el-form-item label="下单时间:" required>
                  <span class="label-right">用户在</span>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderStartTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :disabled="activityData.isStart"
                      :picker-options="orderStartPickerOptions"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderEndTime"
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :disabled="activityData.isStart"
                      :picker-options="orderEndPickerOptions"
                      @change="orderEndTimeChange"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="clearOrderTime"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <span class="label-left">期间内下单</span>
                </el-form-item>
                <el-form-item label="金额统计类型:" required>
                  <el-radio-group
                    v-model="ruleForm.orderPaymentType"
                    :disabled="activityData.isStart"
                  >
                    <el-radio :label="1">
                      <span>订单金额（后台价）</span>
                      <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="0" v-if="!isVenderType">
                      <span>用户应付金额</span>
                      <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="2" v-if="!isVenderType">
                      <span>用户实付金额</span>
                      <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                  </el-radio-group>
                  <el-tooltip class="item" effect="dark" content="订单金额：是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                    <div class="new-icon-box" style="margin: -3px 8px"></div>
                  </el-tooltip>
                  <div style="color: red">
                    注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                  </div>
                </el-form-item>
                <el-form-item label="商品要求:" required>
                  <!-- <el-radio-group
                    v-model="ruleForm.filterType"
                    :disabled="activityData.isStart"
                    @change="filterTypeChange"
                  >
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">指定商品</el-radio>
                    <el-radio :label="2">排除商品</el-radio>
                  </el-radio-group>
                  <jd-button
                    type="default"
                    :class="[{ 'global-view-btn': backgroundOpacity }]"
                    :style="{
                      margin: ' 0 0px 0 15px',
                    }"
                    @click="exposureProducts"
                    :disabled="activityData.isStart || ruleForm.filterType == 0"
                  >
                    {{
                      selectGoodsArr.length != ""
                        ? "已选" + selectGoodsArr.length + "个"
                        : "+添加"
                    }}
                  </jd-button> -->
                  <productReqCom
                    :filterType.sync="ruleForm.filterType"
                    :venderIds.sync="ruleForm.venderIds"
                    :sellerSkuList.sync="ruleForm.sellerSkuList"
                    :multiShopGoods.sync="multiShopGoods"
                    :isCreated="isCreated"
                    :isDisabled="activityData.isStart"
                    addGoodText="已选"
                    @changeFilterType="filterTypeChange"
                  />
                </el-form-item>
                <el-form-item label="指定商品规则:" v-if="ruleForm.orderPaymentType==1&&ruleForm.filterType == 1">
                  <el-select style="width: 280px;" v-model="ruleForm.filterSkuType" :disabled="activityData.isStart" placeholder="">
                    <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                    <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                  </el-select>
                  <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                </el-form-item>
                <!-- 指定商品显示配置：仅在指定商品/排除商品时显示 -->
                <el-form-item label="指定商品显示:" v-if="ruleForm.filterType == 1 || ruleForm.filterType == 2">
                  <el-checkbox 
                    v-model="ruleForm.showProductConditon" 
                    :disabled="activityData.isStart">
                    C端不显示指定或排除的商品
                  </el-checkbox>
                </el-form-item>
                <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.mergeOrder"
                  >
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                  <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                </el-form-item>
                <el-form-item label="订单状态:" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.orderType"
                  >
                    <el-radio :label="1">已完成</el-radio>
                    <el-radio :label="0"
                      >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="统计逻辑:" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.countType"
                  >
                    <el-radio :label="0">累计订单</el-radio>
                    <el-radio :label="1"
                      >单笔订单</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="下单跳转链接:" required>
                  <el-radio-group
                    v-model="ruleForm.goShopSetting"
                    :disabled="activityData.isStart"
                    @change="onShopSetChange"
                  >
                    <el-radio :label="0">进入店铺首页</el-radio>
                    <el-radio :label="1">跳转指定小程序</el-radio>
                    <el-radio :label="2">进入指定链接</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-if="ruleForm.goShopSetting == 1">
                  <el-form-item label="小程序appId:" required>
                    <el-input
                      type="textarea"
                      placeholder="请输入小程序appId"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="ruleForm.goShopAppId"
                      :disabled="activityData.isStart"
                      :maxlength="1000"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="页面路径path:">
                    <el-input
                      type="textarea"
                      placeholder="请输入小程序页面路径path"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="ruleForm.goShopUrl"
                      :disabled="activityData.isStart"
                      :maxlength="1000"
                    ></el-input>
                    <div style="color: #f56c6c">
                      注意：path若不写，则默认进入小程序主页。
                    </div>
                  </el-form-item>
                </div>
                <el-form-item
                  label="指定链接:"
                  required
                  v-if="ruleForm.goShopSetting == 2"
                >
                  <el-input
                    type="textarea"
                    placeholder="请输入指定链接"
                    style="width: 425px; margin-left: 8px"
                    show-word-limit
                    v-model="ruleForm.goShopUrl"
                    :disabled="activityData.isStart"
                    :maxlength="1000"
                  ></el-input>
                  <div style="color: #f56c6c">
                    注意：仅可填写京东域内的
                    H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="任务解锁："
            required
            v-if="ruleForm.unlockPrizeType == 2"
          >
            <jd-button
              type="blue"
              :disabled="activityData.isStart || unlockTaskDataList.length >= 3"
              style="margin-bottom: 12px"
              @click="addUnlockTask"
              >+添加任务（{{ unlockTaskDataList.length }}/3）</jd-button
            >
            <span class="active-tip label-left">完成全部任务即可解锁成功</span>

            <el-table
              v-if="unlockTaskDataList.length > 0"
              :data="unlockTaskDataList"
              style="width: 1000px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#f0f2f7',
                'text-align': 'left',
              }"
            >
              <el-table-column label="序号" width="80px">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务类型" align="left">
                <template slot-scope="scope">
                  <span>{{
                    getTaskType(unlockTaskTypeOptions, scope.row)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务条件" prop="condition">
                <template slot-scope="scope">
                  <span>{{ getCondition(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <jd-button
                    type="blueText"
                    :disabled="activityData.isStart"
                    @click="editUnlockTask(scope.row, scope.$index)"
                    >修改</jd-button
                  >
                  <jd-button
                    type="blueText"
                    :disabled="activityData.isStart"
                    @click="deleteUnlockTask(scope.$index)"
                    >删除</jd-button
                  >
                  <jd-button
                    type="blueText"
                    v-if="scope.$index != 0"
                    :disabled="activityData.isStart"
                    @click="up(unlockTaskDataList, scope.$index)"
                    >上移</jd-button
                  >
                  <jd-button
                    type="blueText"
                    @click="down(unlockTaskDataList, scope.$index)"
                    :disabled="activityData.isStart"
                    v-if="scope.$index != unlockTaskDataList.length - 1"
                    >下移</jd-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item
            label="用户消耗:"
            required
            v-if="ruleForm.unlockPrizeType == 3"
          >
            <el-input
              v-model="ruleForm.needPoint"
              placeholder="请输入"
              style="width: 100px"
              :disabled="activityData.isStart"
              @input="
                ruleForm.needPoint = getNumberData(1, $event, 0, 1, 999999)
              "
            ></el-input>
            <span class="label-left">积分即可解锁成功</span>
          </el-form-item>
          <el-form-item label="日历提醒:">
            <el-checkbox
              v-model="ruleForm.calendarRemindFlag"
              :disabled="activityData.isStart"
            >
              添加日历提醒
            </el-checkbox>
            <span class="label-right"
              >（勾选后，解锁奖品后可引导消费者添加开奖提醒）</span
            >
          </el-form-item>
          <jd-title label="增加中奖概率任务设置" type="bold"></jd-title>
            <el-form-item label="c端任务设置：">
                <el-radio-group
                  v-model="ruleForm.taskDisplayType "
                  class="flex-style"
                >
                  <el-radio :label="0">用户解锁奖品后才展示</el-radio>
                  <el-radio :label="1">常显示（即任务常显示，但用户未解锁奖品时不支持做任务，仅引导解锁奖品）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="任务奖励形式：">
                <el-radio-group
                  v-model="ruleForm.taskRewardType"
                  class="flex-style"
                >
                  <el-radio :label="0">幸运值（即完成任务获取幸运值，增加中奖概率）</el-radio>
                  <el-radio :label="1">抽奖码（即完成任务获取抽奖码，增加中奖概率）</el-radio>
                </el-radio-group>
              </el-form-item>
          <el-form-item label="任务设置:">
            <jd-button type="blue" style="margin-bottom: 12px" @click="addTask"
              >+添加任务</jd-button
            >
            <el-table
              v-if="taskDataList.length > 0"
              :data="taskDataList"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="序号" width="80px">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务类型">
                <template slot-scope="scope">
                  <span>{{ getTaskType(taskTypeOptions, scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务条件" prop="condition">
                <template slot-scope="scope">
                  <span>{{ getCondition(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务有效期" prop="taskValidity">
                <template slot-scope="scope">
                  <span v-if="scope.row.taskValidity == 1">活动期间</span>
                  <span v-else>{{
                    scope.row.startTime + "~" + scope.row.endTime
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务次数" prop="count">
                <template slot-scope="scope">
                  <!-- <span>{{
                    scope.row.taskValidity == 1
                      ? `活动期间${taskTypeList.includes(scope.row.taskType) ? '每日' : ''}最多完成${scope.row.finishLimit || 1}次`
                      : `指定时间最多完成${scope.row.finishLimit || 1}次`
                  }}</span> -->
                  <span v-if="scope.row.taskType == 16">{{
                    scope.row.taskValidity == 1
                      ? `活动期间最多完成${scope.row.finishLimit || 1}次`
                      : `指定时间最多完成${scope.row.finishLimit || 1}次`
                  }}</span>
                  <span v-else>{{
                    scope.row.taskValidity == 1
                      ? `活动期间${taskTypeList.includes(scope.row.taskType) ? '每日' : ''}最多完成${scope.row.taskDoLimit || 1}次`
                      : `指定时间${taskTypeList.includes(scope.row.taskType) ? '每日' : ''}最多完成${scope.row.taskDoLimit || 1}次`
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务奖励" prop="count">
                <template slot-scope="scope">
                  <span>{{ scope.row.giveLimit }}{{ruleForm.taskRewardType == 0 ? '个幸运值' : '个抽奖码'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <jd-button
                    type="blueText"
                    :disabled="isCantEdit(scope.row)"
                    @click="editTask(scope.row, scope.$index)"
                    >修改</jd-button
                  >
                  <jd-button
                    type="blueText"
                    :disabled="isCantEdit(scope.row)"
                    @click="deleteTask(scope.$index)"
                    >删除</jd-button
                  >
                  <jd-button
                    type="blueText"
                    v-if="scope.$index != 0"
                    :disabled="
                      isCantEdit(scope.row) ||
                      isCantEdit(taskDataList[scope.$index - 1])
                    "
                    @click="up(taskDataList, scope.$index)"
                    >上移</jd-button
                  >
                  <jd-button
                    type="blueText"
                    @click="down(taskDataList, scope.$index)"
                    :disabled="isCantEdit(scope.row)"
                    v-if="scope.$index != taskDataList.length - 1"
                    >下移</jd-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <jd-title label="奖品设置" type="bold"></jd-title>
          <el-form-item label="开奖时间：" required>
            <!-- <el-date-picker
              v-model="ruleForm.timingPrizeTime"
              type="datetime"
              placeholder="请选择时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              default-time="23:59:59"
              :disabled="activityData.isStart"
              :picker-options="openPickerOptions"
              @change="timingPrizeTimeChange"
            >
            </el-date-picker> -->
              <el-radio-group
                  v-model="ruleForm.timingPrizeDrawType"
                  :disabled="activityData.isStart"
                  @change="timingPrizeCycleTypeChange"
                >
                  <div style="display: flex;align-items: center;">
                    <el-radio :label="0">
                      单次定时开奖
                      <el-date-picker
                        v-model="ruleForm.timingPrizeTime"
                        type="datetime"
                        placeholder="请选择时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="openPickerOptions"
                        @change="timingPrizeTimeChange"
                        style="margin-left: 8px"
                        v-if="ruleForm.timingPrizeDrawType == 0"
                        :disabled="activityData.isStart"
                      >
                      </el-date-picker>
                    </el-radio>
                    <el-radio :label="2">多次定时开奖</el-radio>
                  </div>
                </el-radio-group>
                <span v-if="ruleForm.timingPrizeDrawType == 2" style="margin-left: 16px;color:red">*注意：若设为“多次定时开奖”，则奖品设置中的奖品数量为单次开奖数量（非总库存），每次开奖都按此数量抽取</span>
                                <div class="loop-send-box" v-if="ruleForm.timingPrizeDrawType == 2">
                  <el-form-item label="开奖时间：" required label-width="100px">
                    <div
                      v-for="(item, index) in ruleForm.timingPrizeTimeList"
                      :key="index"
                      style="margin-bottom: 10px"
                    >
                      <el-date-picker
                        v-model="ruleForm.timingPrizeTimeList[index]"
                        type="datetime"
                        placeholder="请选择时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="openPickerOptions2"
                        @change="changeManyOpenTime(index)"
                        style="margin-right: 8px"
                        :disabled="activityData.isStart"
                      />
                      <jd-button
                        type="break"
                        @click="addOpenTime()"
                        v-if="index == 0 && !activityData.isStart && !backgroundOpacity"
                      >添加开奖时间</jd-button>
                      <jd-button
                        type="blueText"
                        @click="removeOpenTime(index)"
                        v-if="index != 0 && ruleForm.timingPrizeTimeList.length > 2 && !activityData.isStart && !backgroundOpacity"
                      >删除</jd-button>
                    </div>
                  </el-form-item>
                </div>
          </el-form-item>
          <el-form-item label="开奖方式：" required>
            <el-radio-group
              v-model="ruleForm.timingPrizeType"
              :disabled="activityData.isStart"
              @change="timingPrizeTypeChange"
            >
              <div style="display: flex; flex-direction: column">
                <el-radio style="margin-top: 10px" :label="0"
                  >商家手动审核开奖（到达开奖时间商家指定中奖人数仍为0时，则中奖人数为0）</el-radio
                >
                <el-radio style="margin-top: 10px" :label="1"
                  >商家手动审核开奖（到达开奖时间商家指定中奖人数仍为0时，则不限参与人数系统随机分配中奖）</el-radio
                >
                <el-radio style="margin-top: 10px" :label="2"
                  >
                  <span>按指定开奖时间不限参与人数自动随机分配中奖</span>
                  <div class="condition-box" v-if="ruleForm.timingPrizeType == 2">
                    <div>中奖条件（不够选则不限制）</div>
                    <div>
                      <el-checkbox v-model="ruleForm.isCheckConsume" @change="isCheckConsumeChange" :disabled="activityData.isStart" :true-label="1" :false-label="0">
                        <span>仅随机抽选在店内消费大于</span>
                        <el-input
                          v-model="ruleForm.trialConsumeAmount"
                          placeholder="请输入"
                          class="w100 mlr8"
                          :disabled="ruleForm.isCheckConsume == 0 ||activityData.isStart"
                          @input="
                            ruleForm.trialConsumeAmount  = getNumberData(1, $event,1,0)
                          "
                        ></el-input>
                        <span>元的用户，不满足则不中奖</span>
                      </el-checkbox>
                    </div>
                  </div>
                  </el-radio
                >
                <el-radio style="margin-top: 5px" :label="3">
                  <span>
                    每
                    <el-input
                      v-model.number="ruleForm.joinNum"
                      placeholder="请输入"
                      style="width: 80px"
                      :disabled="
                        ruleForm.timingPrizeType != 3 || activityData.isStart
                      "
                      @input="
                        ruleForm.joinNum = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          99999999
                        )
                      "
                    ></el-input>
                    人参与可中奖1份奖品，最多不超过总奖品份数，低于
                    <el-input
                      v-model.number="ruleForm.underJoinNum"
                      placeholder="请输入"
                      style="width: 80px"
                      :disabled="
                        ruleForm.timingPrizeType != 3 || activityData.isStart
                      "
                      @input="
                        ruleForm.underJoinNum = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          99999999
                        )
                      "
                    ></el-input>
                    人参与时
                    <el-select
                      v-model="ruleForm.isPrizeType"
                      style="width: 100px"
                      :disabled="
                        ruleForm.timingPrizeType != 3 || activityData.isStart
                      "
                    >
                      <el-option label="不中奖" :value="0"> </el-option>
                      <el-option label="中奖一份" :value="1"> </el-option>
                    </el-select>
                  </span>
                </el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
          <!-- 奖品发放形式 -->
          <el-form-item
            label="奖品发放形式:"
            required
          >
            <div style="display: flex;align-items: center;">
              <el-radio v-model="ruleDto.sendType" :label="0" :disabled="activityData.isStart">立即发放</el-radio>
              <el-radio v-if="ruleForm.unlockPrizeType == 1" @change="ruleDto.sendDay= ''" v-model="ruleDto.sendType" :label="1" :disabled="activityData.isStart">确认收货
                <el-input
                  v-if="ruleDto.sendType == 1"
                  v-model="ruleDto.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleDto.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-radio v-if="ruleForm.unlockPrizeType == 1" @change="ruleDto.sendDay= ''" v-model="ruleDto.sendType" :label="2" :disabled="activityData.isStart">活动结束
                <el-input
                  v-if="ruleDto.sendType == 2"
                  v-model="ruleDto.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleDto.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-tooltip placement="top-start" effect="dark">
                <div slot="content">
                  1.立即发放:用户下单符合条件后，系统立即发放奖品;<br />
                  2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                  3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                </div>
                <div>
                  发放规则<i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="奖品池设置:" required>
            <div>
              <el-radio-group v-model="ruleForm.prizeSettingType">
                <el-radio :label="0">统一奖品池</el-radio>
                <el-radio :label="1" :disabled="ruleForm.unlockPrizeType != 1">
                  阶梯奖品池
                </el-radio>
              </el-radio-group>
              <span class="label-left active-tip"
                >（注意：仅下单解锁方式支持“阶梯奖品池”，满足不同阶梯的用户开奖时按不同奖品池开奖）</span
              >
            </div>
            <template v-if="ruleForm.unlockPrizeType == 1">
              <div class="prize_box" v-if="ruleForm.prizeSettingType == 0">
                <div class="label-left">
                  所下订单需满足以下条件即可解锁以下奖品池（按累计订单统计）
                </div>
                <div class="prize_box_middle">
                  <el-form-item label="消费门槛:" required>
                    <span class="label-right">金额≥</span>
                    <el-input
                      v-model="ruleForm.orderStartPayment"
                      @input="
                        ruleForm.orderStartPayment =
                          ruleForm.orderStartPayment = getNumberData(
                            1,
                            $event,
                            1,
                            0,
                            999999
                          )
                      "
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="activityData.isStart"
                    ></el-input
                    ><span class="label-left label-right">元，且商品件数≥</span>
                    <el-input
                      v-model="ruleForm.itemStartCount"
                      @input="
                        ruleForm.itemStartCount = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          999999
                        )
                      "
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="activityData.isStart"
                    ></el-input>
                    <span class="label-left">件</span>
                  </el-form-item>
                  <el-form-item label="奖品设置:" required>
                    <el-table
                      :data="prizeSettingList"
                      style="width: 1250px; border: 1px solid #f0f0f0"
                      :header-cell-style="{
                        background: '#fafafa',
                        'text-align': 'left',
                      }"
                      :cell-style="{ 'text-align': 'left!important' }"
                    >
                      <el-table-column label="奖品类型">
                        <template slot-scope="scope">
                          {{ getPrizeTypeName(scope.row.prizeType) }}
                          <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                          <span v-if="scope.row.prizeType == 2">京豆</span>
                          <span v-if="scope.row.prizeType == 3">实物</span>
                          <span v-if="scope.row.prizeType == 4">店铺积分</span>
                          <span v-if="scope.row.prizeType == 5">京东E卡</span>
                          <span v-if="scope.row.prizeType == 6"
                            >爱奇艺会员</span
                          >
                          <span v-if="scope.row.prizeType == 7"
                            >京东PLUS会员</span
                          >
                          <span v-if="scope.row.prizeType == 8">现金红包</span>
                          <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                          <span v-if="scope.row.prizeType == 10">礼品卡</span>
                          <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                        </template>
                      </el-table-column>
                      <el-table-column label="值" width="80" prop="price">
                      </el-table-column>

                      <el-table-column label="奖品名称(12个字以内)" width="299">
                        <template slot-scope="scope">
                          <el-input
                            v-model="scope.row.title"
                            :maxlength="12"
                            show-word-limit
                            style="width: 240px"
                          ></el-input>
                        </template>
                      </el-table-column>

                      <el-table-column label="奖品数量" width="180">
                        <template slot-scope="scope">
                          <el-input
                            v-model.number="scope.row.totalAmount"
                            @input.native="
                              (e) =>
                                (scope.row.totalAmount = checkputn(
                                  e,
                                  scope.row,
                                  'jindou'
                                ))
                            "
                            placeholder="请输入"
                            @input="
                              (scope.row.totalAmount = getNumberData(
                                1,
                                $event,
                                0,
                                1,
                                999999
                              )),
                                prizeNum(scope.row)
                            "
                            @blur="beAdd(scope.row)"
                            :disabled="
                              (activityData.isStart && !scope.row.minNum) ||
                              activityData.isStart
                            "
                          ></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="图片(166px*166px)" width="200">
                        <template slot-scope="scope">
                          <img
                            v-if="scope.row.logo"
                            :src="scope.row.logo"
                            style="width: 56px; height: 56px"
                          />
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" width="350">
                        <template slot-scope="scope">
                          <div class="flex-center">
                            <jd-button
                              type="blueText"
                              @click="
                                centerVis(
                                  prizeSettingList,
                                  scope.row,
                                  scope.$index
                                )
                              "
                              :disabled="activityData.isStart"
                              >选择奖品</jd-button
                            >
                            <el-upload
                              class="label-left"
                              action="/jd-hd-web/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUpload"
                              :on-success="
                                (res) => handleUpload(res, scope.row)
                              "
                              :disabled="activityData.isStart"
                            >
                              <jd-button
                                type="blueText"
                                :disabled="activityData.isStart"
                                >上传图片</jd-button
                              >
                            </el-upload>
                            <jd-button
                              class="label-left"
                              type="blueText"
                              v-if="activityData.isStart && scope.row.title"
                              @click="itemAddNum(scope.row)"
                              >增加奖品数量</jd-button
                            >
                            <jd-button
                              v-if="prizeSettingList.length != 1"
                              type="blueText"
                              :class="{
                                'label-left': !(
                                  activityData.isStart && scope.row.title
                                ),
                              }"
                              :disabled="activityData.isStart"
                              @click="del(prizeSettingList, scope.$index)"
                            >
                              删除
                            </jd-button>
                            <jd-button
                              type="blueText"
                              v-if="scope.$index != 0"
                              :disabled="activityData.isStart"
                              @click="up(prizeSettingList, scope.$index)"
                            >
                              上移
                            </jd-button>
                            <jd-button
                              type="blueText"
                              v-if="scope.$index != prizeSettingList.length - 1"
                              :disabled="activityData.isStart"
                              @click="down(prizeSettingList, scope.$index)"
                            >
                              下移
                            </jd-button>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                    <jd-button
                      type="blue"
                      v-if="!activityData.isStart"
                      @click="addSetting"
                      style="margin-top: 12px"
                      >+增加奖品({{ prizeSettingList.length }}/11)</jd-button
                    >
                  </el-form-item>
                </div>
              </div>
              <div class="prize_box" v-if="ruleForm.prizeSettingType == 1">
                <div class="label-left">
                  所下订单需满足对应阶梯条件时，即可解锁对应阶梯奖品池，满足多个阶梯条件时，按最高阶梯奖品池解锁（按累计订单统计）
                </div>
                <el-form-item label="阶梯设置:" required>
                  <jd-button
                    type="blue"
                    v-if="!activityData.isStart"
                    @click="addStep"
                    >+添加阶梯({{ prizeSettingListStep.length }}/5)</jd-button
                  >
                  <div
                    class="prize_box_step"
                    v-for="(item, index) in prizeSettingListStep"
                    :key="index"
                  >
                    <div class="prize_box_step_top">
                      <span>阶梯{{ index + 1 }}</span>
                      <i
                        class="el-icon-delete prize_box_step_top__delete"
                        @click="deleteStep(index)"
                      ></i>
                    </div>
                    <div class="prize_box_step_center">
                      <el-form-item label="消费门槛:" required>
                        <span class="label-right">金额≥</span>
                        <el-input
                          v-model="item.orderStartPayment"
                          @input="
                            item.orderStartPayment = item.orderStartPayment =
                              getNumberData(1, $event, 1, 0, 999999)
                          "
                          style="width: 140px"
                          placeholder="请输入"
                          :disabled="activityData.isStart"
                        ></el-input
                        ><span class="label-left label-right"
                          >元，且商品件数≥</span
                        >
                        <el-input
                          v-model="item.itemStartCount"
                          @input="
                            item.itemStartCount = getNumberData(
                              1,
                              $event,
                              0,
                              1,
                              999999
                            )
                          "
                          style="width: 140px"
                          placeholder="请输入"
                          :disabled="activityData.isStart"
                        ></el-input>
                        <span class="label-left">件</span>
                      </el-form-item>
                      <el-form-item
                        label="奖品设置:"
                        required
                        class="prize_box_step_margin"
                      >
                        <el-table
                          :data="item.table"
                          style="width: 1250px; border: 1px solid #f0f0f0"
                          :header-cell-style="{
                            background: '#fafafa',
                            'text-align': 'left',
                          }"
                          :cell-style="{ 'text-align': 'left!important' }"
                        >
                          <el-table-column label="奖品类型">
                            <template slot-scope="scope">
                              {{ getPrizeTypeName(scope.row.prizeType) }}
                              <!-- <span v-if="scope.row.prizeType == 1"
                                >优惠券</span
                              >
                              <span v-if="scope.row.prizeType == 2">京豆</span>
                              <span v-if="scope.row.prizeType == 3">实物</span>
                              <span v-if="scope.row.prizeType == 4"
                                >店铺积分</span
                              >
                              <span v-if="scope.row.prizeType == 5"
                                >京东E卡</span
                              >
                              <span v-if="scope.row.prizeType == 6"
                                >爱奇艺会员</span
                              >
                              <span v-if="scope.row.prizeType == 7"
                                >京东PLUS会员</span
                              >
                              <span v-if="scope.row.prizeType == 8"
                                >现金红包</span
                              >
                              <span v-if="scope.row.prizeType == 9"
                                >谢谢参与</span
                              >
                              <span v-if="scope.row.prizeType == 10"
                                >礼品卡</span
                              >
                              <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                            </template>
                          </el-table-column>
                          <el-table-column label="值" width="80" prop="price">
                          </el-table-column>

                          <el-table-column
                            label="奖品名称(12个字以内)"
                            width="299"
                          >
                            <template slot-scope="scope">
                              <el-input
                                v-model="scope.row.title"
                                :maxlength="12"
                                show-word-limit
                                style="width: 240px"
                              ></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="奖品数量" width="180">
                            <template slot-scope="scope">
                              <el-input
                                v-model.number="scope.row.totalAmount"
                                @input.native="
                                  (e) =>
                                    (scope.row.totalAmount = checkputn(
                                      e,
                                      scope.row,
                                      'jindou'
                                    ))
                                "
                                placeholder="请输入"
                                @input="
                                  (scope.row.totalAmount = getNumberData(
                                    1,
                                    $event,
                                    0,
                                    1,
                                    999999
                                  )),
                                    prizeNum(scope.row)
                                "
                                @blur="beAdd(scope.row)"
                                :disabled="
                                  (activityData.isStart && !scope.row.minNum) ||
                                  activityData.isStart
                                "
                              ></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="图片(166px*166px)"
                            width="200"
                          >
                            <template slot-scope="scope">
                              <img
                                v-if="scope.row.logo"
                                :src="scope.row.logo"
                                style="width: 56px; height: 56px"
                              />
                            </template>
                          </el-table-column>

                          <el-table-column label="操作" width="350">
                            <template slot-scope="scope">
                              <div class="flex-center">
                                <jd-button
                                  type="blueText"
                                  @click="
                                    centerVis(
                                      item.table,
                                      scope.row,
                                      scope.$index
                                    )
                                  "
                                  :disabled="activityData.isStart"
                                  >选择奖品</jd-button
                                >
                                <el-upload
                                  class="label-left"
                                  action="/jd-hd-web/image/upload"
                                  :show-file-list="false"
                                  :before-upload="beforeUpload"
                                  :on-success="
                                    (res) => handleUpload(res, scope.row)
                                  "
                                  :disabled="activityData.isStart"
                                >
                                  <jd-button
                                    type="blueText"
                                    :disabled="activityData.isStart"
                                    >上传图片</jd-button
                                  >
                                </el-upload>
                                <jd-button
                                  class="label-left"
                                  type="blueText"
                                  v-if="activityData.isStart && scope.row.title"
                                  @click="itemAddNum(scope.row)"
                                  >增加奖品数量</jd-button
                                >
                                <jd-button
                                  v-if="item.table.length != 1"
                                  type="blueText"
                                  :class="{
                                    'label-left': !(
                                      activityData.isStart && scope.row.title
                                    ),
                                  }"
                                  :disabled="activityData.isStart"
                                  @click="del(item.table, scope.$index)"
                                >
                                  删除
                                </jd-button>
                                <jd-button
                                  type="blueText"
                                  v-if="scope.$index != 0"
                                  :disabled="activityData.isStart"
                                  @click="up(item.table, scope.$index)"
                                >
                                  上移
                                </jd-button>
                                <jd-button
                                  type="blueText"
                                  v-if="scope.$index != item.table.length - 1"
                                  :disabled="activityData.isStart"
                                  @click="down(item.table, scope.$index)"
                                >
                                  下移
                                </jd-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                        <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                        <jd-button
                          type="blue"
                          v-if="!activityData.isStart"
                          @click="addSettingStep(item.table)"
                          style="margin-top: 12px"
                          >+增加奖品({{ item.table.length }}/11)</jd-button
                        >
                      </el-form-item>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </template>
          </el-form-item>
          <el-form-item
            label="奖品设置:"
            required
            v-if="ruleForm.unlockPrizeType != 1"
          >
            <el-table
              :data="prizeSettingList"
              style="width: 1250px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left!important' }"
            >
              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  {{ getPrizeTypeName(scope.row.prizeType) }}
                  <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                  <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price">
              </el-table-column>

              <el-table-column label="奖品名称(12个字以内)" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    :maxlength="12"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品数量" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="
                      (e) =>
                        (scope.row.totalAmount = checkputn(
                          e,
                          scope.row,
                          'jindou'
                        ))
                    "
                    placeholder="请输入"
                    @input="
                      (scope.row.totalAmount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )),
                        prizeNum(scope.row)
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="
                      (activityData.isStart && !scope.row.minNum) ||
                      activityData.isStart
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="图片(166px*166px)" width="200">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    style="width: 56px; height: 56px"
                  />
                </template>
              </el-table-column>

              <el-table-column label="操作" width="350">
                <template slot-scope="scope">
                  <div class="flex-center">
                    <jd-button
                      type="blueText"
                      @click="
                        centerVis(prizeSettingList, scope.row, scope.$index)
                      "
                      :disabled="activityData.isStart"
                      >选择奖品</jd-button
                    >
                    <el-upload
                      class="label-left"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="(res) => handleUpload(res, scope.row)"
                      :disabled="activityData.isStart"
                    >
                      <jd-button
                        type="blueText"
                        :disabled="activityData.isStart"
                        >上传图片</jd-button
                      >
                    </el-upload>
                    <jd-button
                      class="label-left"
                      type="blueText"
                      v-if="activityData.isStart && scope.row.title"
                      @click="itemAddNum(scope.row)"
                      >增加奖品数量</jd-button
                    >
                    <jd-button
                      v-if="prizeSettingList.length != 1"
                      type="blueText"
                      :class="{
                        'label-left': !(
                          activityData.isStart && scope.row.title
                        ),
                      }"
                      :disabled="activityData.isStart"
                      @click="del(prizeSettingList, scope.$index)"
                    >
                      删除
                    </jd-button>
                    <jd-button
                      type="blueText"
                      v-if="scope.$index != 0"
                      :disabled="activityData.isStart"
                      @click="up(prizeSettingList, scope.$index)"
                    >
                      上移
                    </jd-button>
                    <jd-button
                      type="blueText"
                      v-if="scope.$index != prizeSettingList.length - 1"
                      :disabled="activityData.isStart"
                      @click="down(prizeSettingList, scope.$index)"
                    >
                      下移
                    </jd-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            <jd-button
              type="blue"
              v-if="!activityData.isStart"
              @click="addSetting"
              style="margin-top: 12px"
              >+增加奖品({{ prizeSettingList.length }}/11)</jd-button
            >
          </el-form-item>
          <el-form-item label="附加奖品:">
            <el-checkbox
              v-model="ruleForm.isAdditionPrize"
              :disabled="activityData.isStart"
            >
              开启附加奖品
              <span class="active-tip">
                （开启则表示用户符合中奖条件后，中奖用户同时获得的奖品；如不开启则仅获得抽中的奖品）
              </span>
            </el-checkbox>
            <el-table
              v-if="ruleForm.isAdditionPrize"
              :data="prizeSettingListOther"
              style="width: 1250px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  {{ getPrizeTypeName(scope.row.prizeType) }}
                  <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                  <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price">
              </el-table-column>

              <el-table-column label="奖品名称" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    :maxlength="12"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品数量" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="
                      (e) =>
                        (scope.row.totalAmount = checkputn(
                          e,
                          scope.row,
                          'jindou'
                        ))
                    "
                    placeholder="请输入"
                    @input="
                      (scope.row.totalAmount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )),
                        prizeNum(scope.row)
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="
                      (activityData.isStart && !scope.row.minNum) ||
                      activityData.isStart
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品图片(166px*166px)" width="200">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    style="width: 56px; height: 56px"
                  />
                </template>
              </el-table-column>

              <el-table-column label="操作" width="320">
                <template slot-scope="scope">
                  <div class="flex-center">
                    <jd-button
                      type="blueText"
                      @click="
                        centerVis(
                          prizeSettingListOther,
                          scope.row,
                          scope.$index
                        )
                      "
                      :disabled="activityData.isStart"
                      >选择奖品</jd-button
                    >
                    <el-upload
                      class="label-left"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="(res) => handleUpload(res, scope.row)"
                      :disabled="activityData.isStart"
                    >
                      <jd-button
                        type="blueText"
                        :disabled="activityData.isStart"
                        >上传图片</jd-button
                      >
                    </el-upload>
                    <jd-button
                      class="label-left"
                      type="blueText"
                      v-if="activityData.isStart && scope.row.title"
                      @click="itemAddNum(scope.row)"
                      >增加奖品数量</jd-button
                    >
                    <jd-button
                      v-if="scope.row.price"
                      type="blueText"
                      :class="{
                        'label-left': !(
                          activityData.isStart && scope.row.title
                        ),
                      }"
                      :disabled="activityData.isStart"
                      @click="itemDelAdditional"
                      >删除</jd-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
             <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
          </el-form-item>
          <el-form-item label="占位图：">
            <el-checkbox
              v-model="ruleForm.isCustomPlaceholderImage"
              :true-label="1"
              :false-label="0"
              :disabled="activityData.isStart"
            >
              自定义占位图
              <dy-tip color="text">
                （开启则表示奖品不足4个时，剩余位置默认展示自定义占位图）
              </dy-tip>
            </el-checkbox>
            <el-form-item label="奖品占位图片：" required v-if="ruleForm.isCustomPlaceholderImage==1">
              <div style="display: flex; align-items: center;">
                <el-upload
                  style="height: 86px;"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeCustom"
                  :on-success="sussessCustom"
                  :disabled="activityData.isStart"
                  accept="image/gif,image/jpg,image/png"
                >
                  <div style="width: 85px; height: 85px; border: 1px dotted #ccc;display: flex;align-items: center;justify-content: center;border-radius: 4px;">
                    <img v-if="ruleForm.customPlaceholderImage" style="width: 100%; height: 100%" :src="ruleForm.customPlaceholderImage"/>
                    <i v-else class="el-icon-plus"></i>
                  </div>
                </el-upload>
                <div style="margin: 0 10px; color: #999">
                  <jd-button type="blueText" :disabled="activityData.isStart" @click="ruleForm.customPlaceholderImage = prizeDefaultImg">重置</jd-button>
                  <div>尺寸建议：166*166px</div>
                  <div>格式：jpg、png、gif</div>
                </div>
              </div>
            </el-form-item>
          </el-form-item>
          <activityPageSettings 
            isShowShopName
            isShowShopNameByChannel
            v-model="ruleForm"
            :giftList="newGiftList"
            :templateId="templateId"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            :widthNumber="750" 
            :heightNumber="1948"
            defaultTitleKey="activityTheme"
            defaultDescKey="activityRemark"
            defaultTitleColorKey="textColor"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/定时开奖.psd"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/9d63d08861a6425a9d0ea75c5197fecc.png"
            @selectTemplate="getSelectTemplate"
          >
        <template #otherSetMiddle>
         <el-form-item label="奖品展示样式:">
          <el-radio-group
                  v-model="ruleForm.templateType"
                  :disabled="activityData.isStart"
                  @change="getNewPolite(true)"
                >
               <el-radio :label="1">空间旋转效果</el-radio>
               <el-radio :label="2">平面轮播效果</el-radio>
              </el-radio-group>
         </el-form-item>
         <el-form-item label="奖品名称设置:">
          <div class="upload-box">
            <el-form-item label="奖品名称背景颜色:" v-if="ruleForm.templateType==2">
              <div class="flexc-cen-x">
                <el-color-picker
                  v-model="customerPaperwork.bgColor"
                  :disabled="backgroundOpacity"
                >
                </el-color-picker>
                <jd-button
                  class="ml16"
                  type="blueText"
                  :disabled="backgroundOpacity"
                  @click="customerPaperwork.bgColor= currrentRgb"
                  >重置</jd-button
                >
              </div>
            </el-form-item>
            <el-form-item label="奖品名称文字颜色:">
              <div class="flexc-cen-x">
                <el-color-picker
                  v-model="customerPaperwork.prizeNameColor"
                  :disabled="backgroundOpacity"
                >
                </el-color-picker>
                <jd-button
                  class="ml16"
                  type="blueText"
                  :disabled="backgroundOpacity"
                  @click="customerPaperwork.prizeNameColor= currrentRgb2"
                  >重置</jd-button
                >
              </div>
            </el-form-item>
            <el-form-item label="名称背景不透明度：" label-width="145px" v-if="ruleForm.templateType==2">
                <div class="flexc-cen-x">
                  <el-slider
                    class="w200"
                    v-model="customerPaperwork.bgOpacity"
                    :step="1"
                    :min="0"
                    :max="100"
                  ></el-slider>
                  <el-input
                    @input="
                      customerPaperwork.bgOpacity = +getNumberData(
                        1,
                        $event,
                        0,
                        0,
                        100
                      )
                    "
                    v-model="customerPaperwork.bgOpacity"
                    class="w60 ml16"
                  ></el-input
                  ><span class="ml8">%</span>
                </div>
              </el-form-item>
          </div>
         </el-form-item>
        </template>
        <template #otherSet>
          <el-form-item label="是否显示中奖名单:">
            <el-radio-group v-model="ruleForm.showWinList">
              <el-radio label="0">不显示</el-radio>
              <el-radio label="1">
                显示（开启后表示开奖后活动页显示中奖名单信息）
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否显示参与名单:">
            <el-radio-group v-model="ruleForm.showJoinList">
              <el-radio label="0">不显示</el-radio>
              <el-radio label="1">
                显示（开启后表示活动页显示所有参与名单信息）
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        </activityPageSettings>

          <exposureList 
            v-model="itemListForFilter"
            :backgroundOpacity="backgroundOpacity"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
            :isLimit="true"
            :limitNum="limitNum"
            :isEdit="isCreated" 
            :multiShopSkuType.sync="multiShopSkuType" 
            :multiShopGoods="multiShopGoods" 
            :skuBelongVenderId="skuBelongVenderId"
          />
          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox" style="z-index: 1">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[
                { add_btn1: ruleForm.exposureSwitch },
                { 'global-view-btn': backgroundOpacity },
              ]"
              style="margin: 0 15px"
              @click="exposureProductsFiter"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListForFilter.length != ""
                  ? "添加曝光商品" +
                    "(" +
                    itemListForFilter.length +
                    "/20" +
                    ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListForFilter.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <template>
            <sharFrom 
              v-model="ruleForm"
              :sharePic="sharePic"
            />
            <!-- <jd-title label="分享设置" type="bold"></jd-title>
            <el-form-item label="小程序分享标题:" required>
              <el-input
                type="text"
                style="width: 425px"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享简介:" required>
              <el-input
                type="text"
                style="width: 425px"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享图片:" required>
              <div class="miniAppPic">
                <div class="top">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUpload1"
                    :on-success="handleUpload1"
                  >
                    <jd-button type="blueText">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    style="margin-left: 20px"
                    @click="picUrlReset1"
                    >重置</jd-button
                  >
                </div>
                <div class="bottom">
                  <el-image
                    class="elImg"
                    :src="ruleForm.sharePic"
                    fit="contain"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-image>
                  <div class="tips1">
                    <p>建议上传尺寸：200px * 200px</p>
                    <p>图片大小：1MB以内</p>
                    <p>格式：jpg、png</p>
                  </div>
                </div>
              </div>
            </el-form-item> -->
          </template>
          <activityRules 
            v-model="ruleForm.ruleDescription" 
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                position: relative;
              "
            >
              <el-input
                :maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                show-word-limit
              >
              </el-input>
              <div style="margin-top: 16px">
                <jd-button type="blue" @click="generateRule"
                  >生成规则</jd-button
                >
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->

          <!-- <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 99">
      <jd-button
        style="margin-right: 8px"
        v-show="!itemId && backgroundOpacity"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="break"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="break">保存设置</jd-button>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="48"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="break"
          style="margin-left: 8px"
          >确 定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 解锁任务弹窗 -->
    <unlockTaskDialog
      v-if="unlockTaskDialog"
      :taskDataLists="unlockTaskDataList"
      :taskDialog="unlockTaskDialog"
      :currentIndex="currentIndex"
      :isTaskEdit="isUnlockTaskEdit"
      :taskTypeOptions="unlockTaskTypeOptions"
      :taskData="unlockTaskForm"
      @getTaskDataList="getUnlockTaskDataList"
      @closeTask="unlockTaskDialog = false"
      :ruleForm="ruleForm"
      :venderType="venderType"
    ></unlockTaskDialog>
    <!-- 添加任务弹窗 -->
    <addTaskDialog
      v-if="taskDialog"
      :taskDataLists="taskDataList"
      :taskDialog="taskDialog"
      :currentIndex="currentIndex"
      :activityTimeValue="[]"
      :isTaskEdit="isTaskEdit"
      :taskTypeOptions="taskTypeOptions"
      :taskData="taskForm"
      @getTaskDataList="getTaskDataList"
      @closeTask="closeTask"
      :ruleForm="ruleForm"
      :giftText="ruleForm.taskRewardType == 0 ? '个幸运值' : '个抽奖码'"
      :isNotDefaultTaskTime="true"
      :limitGiftNum="99"
      :venderType="venderType"
    ></addTaskDialog>
  </div>
</template>

<script>
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import draggable from "vuedraggable";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import unlockTaskDialog from "./components/unlock_task_dialog.vue";
import addTaskDialog from "./components/add_task_dialog.vue";
import QRCode from "qrcodejs2";
import {
  timePrizeSave,
  getTimePrizeDetail,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { publicOpen } from "@/api/jhk/public";
import informationForm from "./components/informationForm.vue";
import activityRules from "./components/activityRules.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
import btnSet from "./components/commCustomizationSet/btnSet.vue";
const defaultTextColor = "#ffffff";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    unlockTaskDialog,
    addTaskDialog,
    informationForm,
    activityRules,
    exposureList,
    sharFrom,
    activityPageSettings,
    orderShopCom,
    productReqCom,
    btnSet
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    openPickerOptions() {
      return {
        disabledDate: (time) => {
          const { startTime, endTime } = this.ruleForm;
          if (!startTime || !endTime) return true;
          const startStamp = new Date(startTime).getTime() - 8.64e7;
          const endStamp = new Date(endTime).getTime() - 48 * 60 * 60 * 1000;
          return time.getTime() < startStamp || time.getTime() > endStamp;
        },
      };
    },
    openPickerOptions2() {
      return {
        disabledDate: (time) => {
          const { startTime, endTime } = this.ruleForm;
          if (!startTime || !endTime) return true;
          const startStamp = new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          const endStamp = new Date(endTime).getTime();
          return time.getTime() < startStamp || time.getTime() > endStamp;
        },
      };
    },
    // 获取解锁任务类型
    getTaskType() {
      return (arr, row) => {
        const obj = arr.find((item) => item.value == row.taskType);
        return obj.label;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const {
          taskType,
          taskCondition,
          itemStartCount,
          orderStartPayment,
          orderType,
        } = item;
        let str = taskCondition;
        if (taskType == 3) {
          str = `成功浏览${taskCondition}件商品`;
        } else if (taskType == 4) {
          str = `成功加购${taskCondition}件商品`;
        } else if (taskType == 9) {
          str = `成功分享${taskCondition}次商品`;
        } else if (taskType == 10) {
          str = `成功分享${taskCondition}次店铺`;
        } else if (taskType == 11) {
          str = `成功分享${taskCondition}次活动`;
        } else if (taskType == 12) {
          str = `成功预约${taskCondition}件商品`;
        } else if (taskType == 16) {
          str = `消耗${taskCondition}积分`;
        } else if (taskType == 17) {
          str = `在规定时间范围内，购买商品大于等于：${
            itemStartCount ? `${itemStartCount}件` : ""
          }${
            orderStartPayment ? `${orderStartPayment}元` : ""
          }，且订单状态为：${orderType == 1 ? "已完成" : "已付款"}`;
        } else if (taskType == 5) {
          str = `成功浏览会场${item.viewTime || 1}秒`;
        } else if (taskType == 18) {
          str = `成功邀请好友入会${item.inviteLimit}次`;
        }
        return str;
      };
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId || '';
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
    isPop() {
      return this.multiShopGoods.every((item) => !item.venderType);
    },
    isGray() {
      return this.$store.getters.loginUserInfo.isGray;
    }
  },
  watch: {
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if(newVal) {
    //     this.ruleForm.orderPaymentType = 0
    //   } else {
    //     this.ruleForm.orderPaymentType = 1
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.ruleForm.orderPaymentType = 1
      } 
      // else {
      //   this.ruleForm.orderPaymentType = 0
      // }
    },
  },
  data() {
    return {
      currrentRgb: "",
      currrentRgb2: "",
      customerPaperwork: {
        bgColor: "#000000",
        bgOpacity: 50,
        prizeNameColor: "#1A1A1A",
      },
      multiShopGoods: [],
      multiShopSkuType: 0,
      skuBelongVenderId: "",
      limitNum: 20,
      isCreated: false,
      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      templateId: "",
      tabActive: 0,
      navItem: "",
      giftList: [],
      newGiftList: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      itemArr: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      echoDate: {},
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      showSelectProduct: false,
      // 1.14迭代 指定入会时间
      ruleDto: {
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
        isForceRemind: false,
        cusTemplateJSON: "",
        sendType: 0, // 奖品发放形式: 0立即发放, 1确认收货后, 2活动结束后
        sendDay: "", // 发放天数，当sendType为1或2时有效
      },
      isKeyActivity: 0,
      placementPosition: [],
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      orderStartPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() >
              new Date(this.ruleForm.orderEndTime).valueOf() - 8.64e7
            );
          } else {
            return false;
          }
        },
      },
      // 下单结束时间<=活动结束时间、下单结束时间<=开奖时间
      orderEndPickerOptions: {
        disabledDate: (time) => {
          return (
            (this.ruleForm.orderStartTime &&
              time.getTime() <
                new Date(this.ruleForm.orderStartTime).valueOf()) ||
            (this.ruleForm.endTime &&
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()) ||
            (this.ruleForm.timingPrizeTime &&
              time.getTime() >
                new Date(this.ruleForm.timingPrizeTime).valueOf())
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },

      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      localStepNum: 0, // 将外部传入的步骤赋值到本地，避免直接更改props
      mainImagelist: [], //图片拖拽排序
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      selectGoodsStateFilter: false,
      ruleForm: {
        radio: 0,
        exposureSwitch: false,
        activityName: "",
        startTime: null,
        endTime: null,
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],

        unlockPrizeType: 0, // 解锁方式
        prizeSettingType: 0,
        orderStartTime: null,
        orderEndTime: null,
        orderPaymentType: 1,
        filterType: 0,
        filterSkuType: 0,
        itemStartCount: null,
        orderStartPayment: null,
        orderType: 1,
        countType: 0,
        needPoint: null,

        timingPrizeDrawType:0,//开奖时间类型
        timingPrizeTime: null, // 开奖时间
        timingPrizeTimeList: ["", ""], // 多次定时开奖次数
        taskDisplayType:0,
        taskRewardType:0,
        timingPrizeType: 2, // 开奖方式
        isCheckConsume : 0, // 中奖条件
        calendarRemindFlag: false, // 日历提醒
        trialConsumeAmount : "", // 消费金额
        templateType:1,

        joinNum: "",
        underJoinNum: "",
        isPrizeType: 0,
        isAdditionPrize: false,

        activityTheme: "时来运转",
        activityRemark: "定时抽好礼·惊喜享不停",
        textColor: defaultTextColor,
        showWinList: "0", // 中奖名单是否显示
        showJoinList: "0", // 参与名单是否显示

        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片
        isCustomPlaceholderImage: 0,
        customPlaceholderImage: "",
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        openCardFollow: 0,
        isValidBlackList: 0,
        venderIds: [],
        sellerSkuList: [],
        showProductConditon: false,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        goShopUrl: "",
        mergeOrder: false,
      },
      prizeDefaultImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/prize_default_img.png",
      // 解锁任务
      isUnlockTaskEdit: false,
      unlockTaskDialog: false,
      unlockTaskDataList: [],
      unlockTaskForm: {},
      unlockTaskTypeOptions: [
        {
          label: "购买商品",
          value: 17,
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
        },
        {
          label: "关注店铺",
          value: 6,
          taskCondition: "成功关注店铺",
        },
        {
          label: "预约商品",
          value: 12,
        },
      ],
      currentIndex: null,
      // 中奖概率任务设置
      taskDialog: false,
      taskDataList: [],
      taskTypeOptions: [
        {
          label: "每日签到",
          value: 1,
          taskCondition: "成功签到1次",
          activityType: 1,
        },
        {
          label: "浏览店铺",
          value: 2,
          taskCondition: "成功浏览店铺1次",
          activityType: 1,
        },
        {
          label: "浏览商品",
          value: 3,
          activityType: 1,
        },
        {
          label: "加购商品",
          value: 4,
          activityType: 1,
        },
        {
          label: "分享商品",
          value: 9,
          activityType: 1,
        },
        {
          label: "分享店铺",
          value: 10,
          activityType: 1,
        },
        {
          label: "分享活动",
          value: 11,
          activityType: 1,
        },
        {
          label: "浏览会场",
          value: 5,
          taskCondition: "成功浏览会场",
          activityType: 1,
        },
        {
          label: "预约商品",
          value: 12,
          activityType: 2,
        },
        {
          label: "积分兑换",
          value: 16,
        },
        {
          label: "购买商品",
          value: 17,
          activityType: 2,
        },
        {
          label: "邀请好友入会",
          value: 18,
          taskCount: "活动期间每日最多完成YY次",
          activityType: 2,
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
          taskCount: "活动期间每日最多完成1次",
          activityType: 2,
        },
        {
          label: "关注店铺",
          value: 6,
          taskCondition: "成功关注店铺",
          taskCount: "活动期间每日最多完成1次",
          activityType: 2,
        },
        {
          label: "搜索关键词",
          value: 23,
          taskCondition: "成功查询关键词",
          taskCount: "活动期间每日最多完成1次",
          activityType: 1,
        },
      ],
      taskForm: {},
      sharePic: "", // 初始图
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      prizeSettingListStep: [
        {
          orderStartPayment: null,
          itemStartCount: null,
          table: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
        },
        {
          orderStartPayment: null,
          itemStartCount: null,
          table: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
        },
      ],
      prizeSettingListOther: [
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      index: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      jdCrm: {
        startTime: "",
        endTime: "",
        isCrm: false,
      },
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      toAddItem: null,
      toAddRow: null,
      isShowAddNum: false,
      isFirstTime: true,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow.png",
      uploadSize: true,
      taskTypeList:[1,2,3,4,9,10,11,5,23]
    };
  },
  created() {
    // 自营店铺金额统计类型
    if (this.venderType) {
      this.ruleForm.orderPaymentType = 1;
    }
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.initData()
    this.getLevel();
    this.publicOpen();
    this.getDetail();
    // this.hdTaskTemplateGroup();
      // 新增活动-初始化活动时间
      if (!this.valueRow && this.isFirstTime) {
        this.isFirstTime = false;
        this.setTime();
        this.activityTimeChange();
        // 默认开奖时间为活动结束时间的前的48小时
        if (this.ruleForm.endTime) {
          this.ruleForm.timingPrizeTime = this.moment(
            new Date(this.ruleForm.endTime).valueOf() - 48 * 60 * 60 * 1000
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      }
  },

  methods: {
    getSelectTemplate(index, id, item) {
      this.templateId = id;
      const obj = this.newGiftList.find(item => item.id == id)
      if(obj) {
        let configJson = {}
        if(obj.configJson) {
          configJson = JSON.parse(obj.configJson)
        }
        this.customerPaperwork.bgColor = obj.rgb2 || "#000000";
        this.customerPaperwork.prizeNameColor = obj.rgb3 ||(this.ruleForm.templateType==1?"#1A1A1A":"#FFFFFF");
        this.customerPaperwork.bgOpacity = configJson.prizeNameBgOpacity*1 || 50
        this.currrentRgb = obj.rgb2 || "#000000"
        this.currrentRgb2 = obj.rgb3 ||(this.ruleForm.templateType==1?"#1A1A1A":"#FFFFFF");
      }
    },
    getSet() {
      if(this.newGiftList.length) {
        const obj = this.newGiftList[0]
        let configJson = {}
        if(obj.configJson) {
          configJson = JSON.parse(obj.configJson)
        }
        this.customerPaperwork.bgColor = obj.rgb2 || "#000000";
        this.customerPaperwork.prizeNameColor = obj.rgb3 ||(this.ruleForm.templateType==1?"#1A1A1A":"#FFFFFF");
        this.customerPaperwork.bgOpacity = configJson.prizeNameBgOpacity*1 || 50
        this.currrentRgb = obj.rgb2 || "#000000"
        this.currrentRgb2 = obj.rgb3 ||(this.ruleForm.templateType==1?"#1A1A1A":"#FFFFFF");
      }
    },
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    timingPrizeTypeChange() {
      this.ruleForm.isCheckConsume = 0;
      this.ruleForm.trialConsumeAmount = "";
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = "";
      this.ruleForm.goShopUrl = "";
    },
    isCheckConsumeChange() {
      this.ruleForm.trialConsumeAmount  = "";
    },
    initData() {
      this.ruleForm.venderIds = [this.venderId];
      this.ruleForm.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, [this.venderId]);
    },
    addOpenTime() {
      if(this.ruleForm.timingPrizeTimeList.length >= 10) {
        return this.$message.warning("最多设置10个开奖时间");
      }
      this.ruleForm.timingPrizeTimeList.push("");
    },
    removeOpenTime(index) {
      this.ruleForm.timingPrizeTimeList.splice(index, 1);
    },
    changeManyOpenTime(index) {
      let openTime = new Date(this.ruleForm.timingPrizeTimeList[index]).getTime();
      let activityStartTime = new Date(this.ruleForm.startTime).getTime();
      let activityEndTime = new Date(this.ruleForm.endTime).getTime();
      if(openTime && activityStartTime && openTime < activityStartTime) {
        this.ruleForm.timingPrizeTimeList[index] = this.ruleForm.startTime;
        this.$forceUpdate()
      }
      if(openTime && activityEndTime && openTime > activityEndTime) {
        this.ruleForm.timingPrizeTimeList[index] = this.ruleForm.endTime;
        this.$forceUpdate()
      }
      // 选择的开奖时间不能重复
      let isRepeat = this.ruleForm.timingPrizeTimeList.some((item,i) => {
        if(index != i && item == this.ruleForm.timingPrizeTimeList[index]) {
          return true;
        }
      })
      if(isRepeat) {
        this.$message.warning("开奖时间不能重复");
        this.ruleForm.timingPrizeTimeList[index] = "";
        this.$forceUpdate()
        return;
      }
    },
    // 验证发放天数输入
    validSe(e) {
      const num = String(e).replace(/\D/g, '');
      if (num && num > 365) {
        this.$message.warning('天数不能大于365天');
        return '365';
      }
      return num;
    },
    
    //上传图片前校验
    beforeCustom(file) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".gif"];
      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        return false;
      }
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        const valid = image.width == 166 && image.height == 166;
        file.isFlag = valid;
        _this.uploadSize = valid;
        if (!valid) {
          _this.$message.warning("图片尺寸不符合要求，请重新上传");
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
    },
    sussessCustom(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.ruleForm.customPlaceholderImage = res.data;
          this.$message.success("图片上传成功");
        }
      }
    },
    // 中奖概率操作按钮
    isCantEdit(row) {
      return row.hasOwnProperty("id") && this.activityData.isStart;
    },
    // 商品要求
    filterTypeChange(val) {
      this.ruleForm.filterSkuType = 0;
      // if (val == 0) {
      //   this.selectGoodsArr = [];
      // } else if (val == 1) {
      //   this.selectGoodsArr = this.includeArr;
      // } else if (val == 2) {
      //   this.selectGoodsArr = this.excludeArr;
      // }
    },
    // 改变数量值
    confirmAdd(num) {
      this.toAddRow.totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(row) {
      this.toAddRow = row;
      this.toAddItem = {
        ...row,
        num: row.totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListForFilter = [];
        this.mainImagelist = [];
        this.selectGoodsFilterArr = [];
      }
    },
    selectGoodsCloseFilter(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
        this.mainImagelist = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      const order = this.mainImagelist.map((item) => item.skuId);
      this.itemListForFilter.sort((a, b) => {
        return order.indexOf(a.skuId) - order.indexOf(b.skuId);
      });
      this.selectGoodsFilterArr = this.itemListForFilter;
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (Number(row.totalAmount) < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 奖品logo校验
    async beforeUpload(file) {
      const status = await this.imgchecked(file, 166, 166);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 奖品logo上传成功
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.logo = res.data;
      }
    },
    //上传图片前校验   分享设置
    async beforeUpload1(file) {
      const status = await this.imgchecked(file);
      console.log(status);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.ruleForm.sharePic = res.data;
      }
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      if(!(this.valueRow && this.valueRow.id)) {
        this.templateId = this.giftList[0].id;
      } 
      this.pageData.total = data.total * 1;
      // 根据this.ruleForm.templateType来筛选只保留this.giftList里面item的layout和templateType一致的
      this.$nextTick(() => {
        this.getCodeIMG();
      });
      this.getNewPolite()
      if(!(this.valueRow && this.valueRow.id)) {
        this.getSet()
      } else {
        const obj = this.newGiftList.find((item)=>item.id == this.templateId)
        this.currrentRgb = obj.rgb2 || "#000000"
        this.currrentRgb2 = obj.rgb3 ||(this.ruleForm.templateType==1?"#1A1A1A":"#FFFFFF");
      }
    },

    getNewPolite(e) {
      let newGiftList = this.giftList.filter(item => item.layout == this.ruleForm.templateType)
      this.newGiftList = newGiftList
      if(e){
        this.templateId = newGiftList[0].id
        this.getSet()
      }
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `${url}${this.giftList[index].imageUrl}`,
        });
      }
    },

    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //生成规则
    generateRule() {
      let text1 = "奖品解锁方式：",
        text2 = "",
        text3 = "有效订单不包含售中退款/售后退款，如成功参与活动的用户对商品订单进行售后行为，导致实际支付金额不足活动门槛金额的，或者因客户原因导致的恶意退款，视为用户不符合中奖资格，商家有权取消该用户获取奖品的资格。",
        text4 = "实物奖品需填写收货地址后进行发货；若收货地址填写截止时间前未填写收货信息视为自动放弃中奖资格，奖品失效处理，且奖品不予补发！",
        text5 = "",
        text6 = "",
        text7 = "",
        shopText="下单店铺："+this.multiShopGoods.map((item) => item.shopTitle).join("、"),
        text8 =
          "若用户存在刷奖等恶意行为，一经发现将取消获奖资格（如奖品已经发放，有权追回奖品）",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember,true)


        text1 += `${
        this.ruleForm.unlockPrizeType == 0
          ? "符合参与对象后，方可点击“解锁奖品”按钮手动参与抽奖;"
          : this.ruleForm.unlockPrizeType == 1
          ? "下单符合以下条件后，方可点击“解锁奖品”按钮手动参与抽奖;"
          : this.ruleForm.unlockPrizeType == 2
          ? "完成以下所有任务后，方可点击“解锁奖品”按钮手动参与抽奖;"
          : `手动点击“解锁奖品”按钮，并消耗${this.ruleForm.needPoint}积分方可参与抽奖`
      }`;
      if(this.ruleForm.prizeSettingType==0) {
          text2 += "统一奖品\n"
          let prizeText = this.prizeSettingList.map((item,index)=>{
            let text = `（${index+1}）奖品${index+1}：${item.title}，共${item.totalAmount}份${item.prizeType==3 ? ('，单份奖品价值'+item.price+'元') : ''}；`
            if(index<this.prizeSettingList.length-1) {
              text += `\n`
            }
            return text
          })
          text2+= prizeText.join("")
        } else {
          text2 += "阶梯奖品\n"
          let orderArr = ['一','二','三','四','五'];
          // let indexType = ['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪']
          let stepList = this.prizeSettingListStep.map((item,index)=>{
            let text = `（${index+1}）阶梯${orderArr[index]}（累计订单金额满${item.orderStartPayment}元，且满${item.itemStartCount}件，可参与该阶梯抽奖）\n`
            item.table.forEach((item2,index2)=>{
              text += `奖品${index2+1}：${item2.title}，共${item2.totalAmount}份${item2.prizeType==3 ? ('，单份奖品价值'+item2.price+'元') : ''}；`
              if(index2<item.table.length-1) {
                text += `\n`
              }
            })
            if(index<this.prizeSettingListStep.length-1) {
              text += `\n`
            }
            return text
          })
          text2+= stepList.join("")
        }

      // 解锁方式
      if (this.ruleForm.unlockPrizeType == 1) {
        let content1 = "";
        let content2 = "";
        let content3 = "";
        const content4 =
          "订单状态：" + (this.ruleForm.orderStatus == 0 ? "已完成" : "已付款");

        if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
          content1 = `下单时间：用户在 ${this.ruleForm.orderStartTime}~${this.ruleForm.orderEndTime} 期间下单`;
        }

        if (this.ruleForm.filterType == 1) {
          content2 = `商品要求：指定商品（只要含指定商品就整单统计）`;
        } else if (this.ruleForm.filterType == 2) {
          content2 = `商品要求：排除商品（只要含排除商品则整单排除）`;
        }

        let itemStartCount;
        let orderStartPayment;

        // 统一奖品池
        if (this.ruleForm.prizeSettingType == 0) {
          itemStartCount = this.ruleForm.itemStartCount;
          orderStartPayment = this.ruleForm.orderStartPayment;
        } else {
          if (this.prizeSettingListStep.length) {
            const itemObj = this.prizeSettingListStep[0];
            itemStartCount = itemObj.itemStartCount;
            orderStartPayment = itemObj.orderStartPayment;
          }
        }

        if (itemStartCount || orderStartPayment) {
          content3 += `消费要求：`;
          if (itemStartCount) {
            content3 += `且商品件数：大于等于${itemStartCount}件`;
          }
          if (orderStartPayment) {
            if (itemStartCount) {
              content3 += `；`;
            }
            content3 += `且订单金额：大于等于${orderStartPayment}元`;
          }
        }

        const contentArr = [content1, content2, content3, content4].filter(
          (item) => item != ""
        );
        contentArr.forEach((item, index) => {
          text6 =
            text6 +
            "\n" +
            `(${index + 1})` +
            item +
            (index == contentArr.length - 1 ? "" : "；");
        });
      } else if (this.ruleForm.unlockPrizeType == 2) {
        this.unlockTaskDataList.forEach((item, index) => {
          if (item.taskType == 17) {
            const text = `在${item.orderStartTime}~${
              item.orderEndTime
            }期间下单付款指定排除商品的订单不计算入内，仅统计购买其他商品的商品件数及金额，${
              item.itemStartCount
                ? `且商品件数：大于等于${item.itemStartCount}件，`
                : ""
            }${
              item.orderStartPayment
                ? `且订单金额：大于等于${item.orderStartPayment}元；`
                : ""
            }且订单状态为：${item.orderType == 1 ? "已完成" : "已付款"}`;
            text6 = text6 + "\n" + `(${index + 1})` + text;
          } else {
            text6 =
              text6 +
              "\n" +
              `(${index + 1})` +
              this.getCondition(item) +
              (index == this.unlockTaskDataList.length - 1 ? "" : "；");
          }
        });
      }

      if(this.ruleForm.timingPrizeDrawType == 0){ 
        if (this.ruleForm.timingPrizeTime) {
          text7 = "开奖时间：" + this.ruleForm.timingPrizeTime;
        }
      }else{
      let numTextArr = ['一','二','三','四','五','六','七','八','九','十'];
        let manyTime = "";
        this.ruleForm.timingPrizeTimeList.forEach((item,index) => {
          manyTime += `（${index+1}）第${numTextArr[index]}次开奖时间：${item}${index == this.ruleForm.timingPrizeTimeList.length - 1 ? '' : ';\n'}`
        })
        text7 = "开奖时间：" + '\n' + manyTime;
      }
      text1 += text6
      let Arr1 = [
        firstText,
        [secondText,text1,shopText],
        [thirdText,text7,text2,text3,text4],
        [fourthText, precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      // let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      // let newText = "";
      // let newNum = 1;
      // Arr1.forEach((item) => {
      //   if (item.length > 0) {
      //     newText = newText + newNum + "." + item + ";" + "\n";
      //     newNum = newNum + 1;
      //   }
      // });

      this.ruleForm.ruleDescription = newText;
    },
    //选择奖品弹窗
    centerVis(arr, row, index) {
      this.itemArr = arr;
      this.index = index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (prizeType == 1) {
        this.itemArr[this.index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.itemArr[this.index].giftType = Number(data.giftType);
      }
      this.itemArr[this.index].price = Number(data.discount);

      this.itemArr[this.index].assetsId = Number(data.couponId || data.skuId);
      this.itemArr[this.index].logo = data.logo || this.defaultLogo;
      this.itemArr[this.index].prizeType = prizeType;

      if (prizeType == 4) {
        this.itemArr[this.index].title = data.discount + "店铺积分";
      } else {
        this.itemArr[this.index].title = data.name;
      }

      if (data.singleAmount) {
        this.itemArr[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.itemArr[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.itemArr[this.index].skuId = data.skuId;
          delete this.itemArr[this.index].isGoodManage;
        } else {
          this.itemArr[this.index].isGoodManage = data.isGoodManage;
        }
        this.itemArr[this.index].predictSendTime = data.predictSendTime;
        this.itemArr[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime || 1;
        this.itemArr[this.index].addressFillEndTime = data.addressFillEndTime;
        this.itemArr[this.index].shouldCollectExtraData = data.shouldCollectExtraData;
        this.itemArr[this.index].extraQuestion = data.extraQuestion;
        this.itemArr[this.index].addressFillLimit = data.addressFillLimit;
        this.itemArr[this.index].commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.itemArr[this.index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.itemArr[this.index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.itemArr[this.index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType==1 &&!this.ruleForm.openCardBeforeDay
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
        if (
          this.ruleForm.firstOpenCardTimeType==2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
      }

      // 下单解锁
      if (this.ruleForm.unlockPrizeType == 1) {
        // 下单时间
        if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
          this.$message.warning("请选择下单时间");
          return;
        }
        if (
          new Date(this.ruleForm.orderEndTime).valueOf() >
          new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.$message.warning("下单结束时间不能大于活动结束时间");
          return;
        }

        if (this.ruleForm.timingPrizeTime) {
          if (
            new Date(this.ruleForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.timingPrizeTime).valueOf()
          ) {
            this.$message.warning("下单结束时间不能大于开奖时间");
            return;
          }
        }
        // 商品要求
        // if (this.ruleForm.filterType == 1 && !this.selectGoodsArr.length) {
        //   this.$message.warning("请选择指定商品");
        //   return;
        // }
        // if (this.ruleForm.filterType == 2 && !this.selectGoodsArr.length) {
        //   this.$message.warning("请选择排除商品");
        //   return;
        // }
        if(this.ruleForm.filterType!=0) {
          const obj = this.ruleForm.sellerSkuList.find((item) => item.skuIds.length==0)
          if(obj) {
            const types = {
              1: "指定",
              2: "排除",
            }
            const shop = this.multiShopGoods.find((item) => item.venderId == obj.venderId)
            this.$message.warning(`请选择${shop.shopTitle}的${types[this.ruleForm.filterType]}商品`);
            return;
          }
        }
        // 下单跳转链接校验
        if (this.ruleForm.goShopSetting == 1 && !this.ruleForm.goShopAppId) {
          this.$message.warning("请输入小程序appId");
          return;
        }
        if (this.ruleForm.goShopSetting == 2) {
          if (!this.ruleForm.goShopUrl) {
            this.$message.warning("请输入指定链接");
            return;
          } else if (
            !this.ruleForm.goShopUrl.startsWith("https://") ||
            !this.ruleForm.goShopUrl.includes("jd.com")
          ) {
            this.$message.warning(
              "输入的内容非链接或为接口无法支持的链接，请重新设置"
            );
            return;
          }
        }
      } else if (this.ruleForm.unlockPrizeType == 2) {
        if (!this.unlockTaskDataList.length) {
          this.$message.warning("请选择任务解锁");
          return;
        }
        const obj = this.unlockTaskDataList.find((item) => item.taskType == 17);
        if (obj) {
          if (
            new Date(obj.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
          ) {
            this.$message.warning(
              "任务解锁中的购买商品任务，下单结束时间不能大于活动结束时间"
            );
            return;
          }
        }
      } else if (
        this.ruleForm.unlockPrizeType == 3 &&
        !this.ruleForm.needPoint
      ) {
        this.$message.warning("请输入用户消耗积分");
        return;
      }

      // 中奖概率任务设置
      if (this.taskDataList.length) {
        // 每日任务
        const obj = this.taskDataList.find((item) => item.taskType == 17);
        if (obj) {
          if (
            new Date(obj.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
          ) {
            this.$message.warning(
              "增加中奖概率中的购买商品任务，下单结束时间不能大于活动结束时间"
            );
            return;
          }
        }
      }

      // 开奖时间
      if (this.ruleForm.timingPrizeDrawType == 0 && !this.ruleForm.timingPrizeTime) {
        this.$message.warning("请选择开奖时间");
        return;
      }

      if (this.ruleForm.timingPrizeDrawType == 0 &&
       ( new Date(this.ruleForm.timingPrizeTime).valueOf() <
        new Date(this.ruleForm.startTime).valueOf())
      ) {
        this.$message.warning("开奖时间不能小于活动开始时间");
        return;
      }

      // 开奖时间校验：必须在活动时间范围内，且需早于活动结束时间10分钟（单次和多次都适用）
      const startTime = new Date(this.ruleForm.startTime).getTime();
      const endTime = new Date(this.ruleForm.endTime).getTime();
      const tenMinutes = 10 * 60 * 1000;

      if (this.ruleForm.timingPrizeDrawType == 0) {
        // 单次定时开奖
        const drawTime = new Date(this.ruleForm.timingPrizeTime).getTime();
        if (drawTime < startTime) {
          this.$message.warning("开奖时间不能小于活动开始时间");
          return;
        }
        if (drawTime > endTime - tenMinutes) {
          this.$message.warning("开奖时间需早于活动结束时间10分钟");
          return;
        }
      } else if (this.ruleForm.timingPrizeDrawType == 2) {
        // 多次定时开奖
        if (!this.ruleForm.timingPrizeTimeList || this.ruleForm.timingPrizeTimeList.length == 0) {
          this.$message.warning("请至少添加一个开奖时间");
          return;
        }
        for (let i = 0; i < this.ruleForm.timingPrizeTimeList.length; i++) {
          const time = this.ruleForm.timingPrizeTimeList[i];
          if (!time) {
            this.$message.warning(`第${i + 1}个开奖时间不能为空`);
            return;
          }
          const drawTime = new Date(time).getTime();
          if (drawTime < startTime) {
            this.$message.warning(`第${i + 1}个开奖时间不能小于活动开始时间`);
            return;
          }
          if (drawTime > endTime - tenMinutes) {
            this.$message.warning(`第${i + 1}个开奖时间需早于活动结束时间10分钟`);
            return;
          }
        }
      }

      if(this.ruleForm.timingPrizeType == 2) {
        if(this.ruleForm.isCheckConsume &&!this.ruleForm.trialConsumeAmount ) {
          this.$message.warning("请完善中奖条件");
          return;
        }
      }
      if (
        this.ruleForm.timingPrizeType == 3 &&
        (!this.ruleForm.joinNum || !this.ruleForm.underJoinNum)
      ) {
        this.$message.warning("开奖方式未填写完整");
        return;
      }

      if (this.ruleForm.prizeSettingType == 0) {
        // 消费门槛
        if (
          this.ruleForm.unlockPrizeType == 1 &&
          !this.ruleForm.itemStartCount &&
          !this.ruleForm.orderStartPayment
        ) {
          this.$message.warning("请输入消费门槛");
          return;
        }
        // 请将奖品填写完整！
        let isFlay = false;

        this.prizeSettingList.forEach((item) => {
          if (!item.prizeType || !item.totalAmount) {
            isFlay = true;
          }
        });

        if (isFlay) {
          this.$message.warning("请将奖品填写完整！");
          return;
        }
      } else {
        if (this.prizeSettingListStep.length < 2) {
          this.$message.warning("最少添加2个阶梯奖品池");
          return;
        }
        let checkStr = "";
        this.prizeSettingListStep.forEach((item, index) => {
          if (!checkStr && !item.itemStartCount && !item.orderStartPayment) {
            checkStr = `请输入阶梯${index + 1}消费门槛`;
          }
        });
        if (checkStr) {
          this.$message.warning(checkStr);
          return;
        }
        const hasItem = this.prizeSettingListStep.some(
          (item) => item.itemStartCount
        );
        if (hasItem) {
          const allHasItem = this.prizeSettingListStep.every(
            (item) => item.itemStartCount
          );
          if (!allHasItem) {
            this.$message.warning(
              "当阶梯消费门槛设置商品件数时，全部阶梯都需要设置商品件数"
            );
            return;
          }
          let rangStr = "";
          this.prizeSettingListStep.forEach((item, index) => {
            if (!rangStr && index != 0) {
              if (
                Number(this.prizeSettingListStep[index - 1].itemStartCount) >=
                Number(item.itemStartCount)
              ) {
                rangStr = `阶梯${index + 1}商品件数要大于阶梯${index}商品件数`;
              }
            }
          });
          if (rangStr) {
            this.$message.warning(rangStr);
            return;
          }
        }
        const hasAmt = this.prizeSettingListStep.some(
          (item) => item.orderStartPayment
        );
        if (hasAmt) {
          const allHasAmt = this.prizeSettingListStep.every(
            (item) => item.orderStartPayment
          );
          if (!allHasAmt) {
            this.$message.warning(
              "当阶梯消费门槛设置订单金额时，全部阶梯都需要设置订单金额"
            );
            return;
          }
          let rangStr = "";
          this.prizeSettingListStep.forEach((item, index) => {
            if (!rangStr && index != 0) {
              if (
                Number(
                  this.prizeSettingListStep[index - 1].orderStartPayment
                ) >= Number(item.orderStartPayment)
              ) {
                rangStr = `阶梯${index + 1}订单金额要大于阶梯${index}订单金额`;
              }
            }
          });
          if (rangStr) {
            this.$message.warning(rangStr);
            return;
          }
        }
        let prizeStr = "";
        this.prizeSettingListStep.forEach((list, index) => {
          list.table.forEach((item) => {
            if (!prizeStr && (!item.prizeType || !item.totalAmount)) {
              prizeStr = `请将阶梯${index + 1}奖品填写完整！`;
            }
          });
        });
        if (prizeStr) {
          this.$message.warning(prizeStr);
          return;
        }
      }

      if (this.ruleForm.isAdditionPrize) {
        // 请将奖品填写完整！
        let isFlay = false;

        this.prizeSettingListOther.forEach((item) => {
          if (!item.prizeType || !item.totalAmount) {
            isFlay = true;
          }
        });

        if (isFlay) {
          this.$message.warning("请将附加奖品填写完整！");
          return;
        }
      }

      if(this.ruleForm.isCustomPlaceholderImage==1) {
        if (!this.ruleForm.customPlaceholderImage) {
          this.$message.warning("请上传自定义占位图");
          return;
        }
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet({customerPaperwork:{
      //   moreActSet: this.ruleForm.moreActSet,
      // }})) {
      //   return;
      // }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListForFilter.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }

      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      const {
        activityName,
        startTime,
        endTime,
        condFollow,
        radio,
        partner,
        ruleDescription,
        unlockPrizeType,
        orderStartTime,
        orderEndTime,
        orderPaymentType,
        filterType,
        filterSkuType,
        itemStartCount,
        orderStartPayment,
        orderType,
        countType,
        prizeSettingType,
        needPoint,
        calendarRemindFlag,
        timingPrizeTime,
        timingPrizeType,
        isCheckConsume,
        trialConsumeAmount,
        joinNum,
        underJoinNum,
        isPrizeType,
        isAdditionPrize,
        activityTheme,
        activityRemark,
        textColor,
        showWinList,
        showJoinList,
        shareTitle,
        shareIntroduce,
        sharePic,
        isCustomPlaceholderImage,
        customPlaceholderImage,
        isValidBlackList,
        sellerSkuList,
        venderIds,
        showProductConditon,
        goShopSetting,
        goShopAppId,
        goShopUrl,
        studentSatus,
        mergeOrder
      } = this.ruleForm;
      const obj = {
        activityName,
        startTime,
        endTime,
        condFollow: Number(condFollow),
        ruleDTO: {},
        priceType: radio, //  0：显示京东价 1：显示促销
        ruleDescription,
        templateId: this.templateId,
        pointActivityPrizeDTOList: [],
        isValidBlackList,
        studentSatus,
      };
      // 活动对象
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
        // 入会时间
        obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
        obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime;
        obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime;
        // 入会时间
        obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay
      }
      // 关注店铺开卡
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow
      // plus会员
      obj.ruleDTO.plusObject = this.ruleDto.plusObject;
      // 强提醒
      obj.ruleDTO.isForceRemind = this.ruleDto.isForceRemind;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      // 活动投放位置
      obj.placementPosition = this.placementPosition.join(",");
      // 自定义背景图
      obj.ruleDTO.cusTemplateJSON = this.ruleDto.cusTemplateJSON || "";
      // 奖品发放形式
      obj.ruleDTO.sendType = this.ruleDto.sendType;
      obj.ruleDTO.sendDay = this.ruleDto.sendDay;
      // 解锁方式
      obj.ruleDTO.unlockPrizeType = unlockPrizeType;
      obj.ruleDTO.showProductConditon = showProductConditon
      if (unlockPrizeType == 1) {
        // 下单时间
        obj.ruleDTO.orderStartTime = orderStartTime;
        obj.ruleDTO.orderEndTime = orderEndTime;
        // 金额统计类型
        obj.ruleDTO.orderPaymentType = orderPaymentType;
        // 订单拆单后是否合并
        obj.ruleDTO.mergeOrder = mergeOrder;

        //商品要求
        obj.ruleDTO.filterType = filterType;
        // 指定商品规则
        obj.ruleDTO.filterSkuType = filterSkuType;
        if(filterType!=0) {
          obj.ruleDTO.itemList = [];
          obj.ruleDTO.skuIdLis = []
        }
        obj.ruleDTO.sellerSkuList = sellerSkuList;
        obj.ruleDTO.venderIds = venderIds;
        // if (filterType == 1) {
        //   obj.ruleDTO.itemList = this.includeArr;
        //   obj.ruleDTO.skuIdList = this.includeArr.map((item) => item.skuId);
        // } else if (filterType == 2) {
        //   obj.ruleDTO.itemList = this.excludeArr;
        //   obj.ruleDTO.skuIdList = this.excludeArr.map((item) => item.skuId);
        // }
        // 订单状态
        obj.ruleDTO.orderType = orderType;
        // 统计逻辑
        obj.ruleDTO.countType = countType;
        // 下单跳转链接
        obj.ruleDTO.goShopSetting = goShopSetting;
        obj.ruleDTO.goShopAppId = goShopAppId;
        obj.ruleDTO.goShopUrl = goShopUrl;
      } else if (unlockPrizeType == 2) {
        // 用type区分解锁传0 增加概率传1
        obj.ruleDTO.taskList = this.unlockTaskDataList.map((item, index) => {
          const obj = {
            ...item,
            type: 0,
            sort: index,
          };
          if ([3, 4, 12].includes(item.taskType)) {
            obj.itemList = item.itemListForFilter;
            if (item.itemListForFilter && item.itemListForFilter.length) {
              obj.skuIds = item.itemListForFilter
                .map((item) => item.skuId)
                .join(",");
            }
            if ([3, 12].includes(item.taskType)) {
              obj.viewCartLimit = item.taskCondition;
            } else {
              // 加购商品
              obj.addCartLimit = item.taskCondition;
            }
          }
          if (item.taskType == 17) {
            obj.itemList = item.selectGoodsFilterArr;
            if (item.selectGoodsFilterArr && item.selectGoodsFilterArr.length) {
              obj.skuIds = item.selectGoodsFilterArr
                .map((item) => item.skuId)
                .join(",");
            }
            obj.skuIds = [];
            obj.venderIds = item.venderIds.join(",");
            obj.sellerSkuList = item.sellerSkuList.map((item)=>{
              return {
                skuIds: item.skuIds,
                venderId: item.venderId
              }
            })
            obj.itemTotalLimit = item.itemStartCount;
            obj.amtLimit = item.orderStartPayment;
            obj.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
          }
          if(item.taskType == 5) {
            obj.viewTime = item.viewTime;
          }
          if(item.taskType == 23) {
            obj.searchKeyword = item.searchKeyword;
          }
          return obj;
        });
      } else if (unlockPrizeType == 3) {
        obj.ruleDTO.needPoint = needPoint;
      }

      // 日历提醒
      obj.ruleDTO.calendarRemindFlag = calendarRemindFlag;

      // 增加中奖概率任务
      if (this.taskDataList.length) {
        let taskList = this.taskDataList.map((item, index) => {
          const obj = {
            ...item,
            type: 1,
            sort: index,
          };
          const itemObj = this.taskTypeOptions.find(
            (list) => list.value == item.taskType
          );
          if (item.taskType != 16 && itemObj) {
            obj.activityType = itemObj.activityType;
          }
          if ([3, 4, 9, 12].includes(item.taskType)) {
            obj.itemList = item.itemListForFilter;
            if (item.itemListForFilter && item.itemListForFilter.length) {
              obj.skuIds = item.itemListForFilter
                .map((item) => item.skuId)
                .join(",");
            }
          }
          // 任务条件
          if ([3, 4, 9, 10, 11, 12].includes(item.taskType)) {
            if (item.taskType == 4) {
              // 加购商品
              obj.addCartLimit = item.taskCondition;
            } else {
              obj.viewCartLimit = item.taskCondition;
            }
          }
          if (item.taskType == 7 || item.taskType == 6) {
            obj.taskDoLimit = 1;
          }
          // 积分兑换
          if (item.taskType == 16) {
            obj.viewCartLimit = item.taskCondition;
            obj.taskDoLimit = item.finishLimit;
          }
          // 邀请好友入会
          if (item.taskType == 18) {
            obj.inviteLimit = item.inviteLimit;
          }
          if (item.taskType == 17) {
            obj.itemList = item.selectGoodsFilterArr;
            if (item.selectGoodsFilterArr && item.selectGoodsFilterArr.length) {
              obj.skuIds = item.selectGoodsFilterArr
                .map((item) => item.skuId)
                .join(",");
            }
            obj.skuIds = [];
            obj.venderIds = item.venderIds.join(",");
            obj.sellerSkuList = item.sellerSkuList.map((item)=>{
              return {
                skuIds: item.skuIds,
                venderId: item.venderId
              }
            })
            obj.itemTotalLimit = item.itemStartCount;
            obj.amtLimit = item.orderStartPayment;
            obj.mergeOrder = item.mergeOrder || false;
            obj.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
          }
          if(this.taskTypeList.includes(item.taskType)) {
            obj.taskDoLimit = item.taskDoLimit;
          }
          return obj;
        });
        if (obj.ruleDTO.taskList) {
          obj.ruleDTO.taskList = obj.ruleDTO.taskList.concat(taskList);
        } else {
          obj.ruleDTO.taskList = taskList;
        }
      }

      // 开奖方式
      obj.ruleDTO.timingPrizeType = timingPrizeType;
      // 中奖条件
      obj.ruleDTO.isCheckConsume = isCheckConsume;
      obj.ruleDTO.trialConsumeAmount = trialConsumeAmount;

      if (timingPrizeType == 3) {
        obj.ruleDTO.joinNum = joinNum;
        obj.ruleDTO.underJoinNum = underJoinNum;
        obj.ruleDTO.isPrizeType = isPrizeType;
      }

      // 奖品池设置
      obj.ruleDTO.prizeSettingType = prizeSettingType;

      if (prizeSettingType == 0) {
        // 奖品设置
        if (this.prizeSettingList.length) {
          obj.pointActivityPrizeDTOList = this.prizeSettingList
            .filter((item) => item.prizeType)
            .map((item) => {
              const prize = {
                ...item,
                taskIndex: 1,
                prizeSettingType,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              return prize;
            });
          if (unlockPrizeType == 1) {
            obj.ruleDTO.stepList = [
              {
                itemLimitCount: itemStartCount,
                orderPaymentLimit: orderStartPayment,
                taskIndex: 1,
              },
            ];
          }
        }
      } else {
        this.prizeSettingListStep.forEach((list, index) => {
          list.table.forEach((item) => {
            if (item.prizeType) {
              const prize = {
                ...item,
                taskIndex: index + 1,
                prizeSettingType,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              obj.pointActivityPrizeDTOList.push(prize);
            }
          });
        });
        // 阶梯
        obj.ruleDTO.stepList = this.prizeSettingListStep.map((item, index) => {
          return {
            itemLimitCount: item.itemStartCount,
            orderPaymentLimit: item.orderStartPayment,
            taskIndex: index + 1,
          };
        });
      }

      // 附加奖品
      obj.ruleDTO.isAdditionPrize = isAdditionPrize;
      if (isAdditionPrize) {
        this.prizeSettingListOther.forEach((item) => {
          if (item.prizeType) {
            const prize = {
              ...item,
              prizeObjectType: 1,
            };
            // 提交地址限制：数组转逗号分隔字符串
            if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
              prize.commitAddressLimit = item.commitAddressLimit.join(',');
            }
            obj.pointActivityPrizeDTOList.push(prize);
          }
        });
      }

      // 活动页设置
      const activitySetting = {
        ...this.customerPaperwork,
        activityTheme,
        activityRemark,
        textColor,
        showWinList,
        showJoinList,
        templateType:this.ruleForm.templateType,
        shopNameType: this.ruleForm.shopNameType,
        // moreActSet: this.ruleForm.moreActSet,
      };
      obj.ruleDTO.customerPaperwork = JSON.stringify(activitySetting);

      // 曝光商品
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0; //是否添加曝光商品 0 否 1 是
      if (obj.isExposureItem) {
        obj.itemList = this.itemListForFilter;
      }
      obj.ruleDTO.multiShopSkuType = this.multiShopSkuType;
      obj.ruleDTO.skuBelongVenderId = this.multiShopSkuType==0 && this.itemListForFilter.length>0 ? this.itemListForFilter[0].belongVenderId : "",

      // 分享设置
      obj.ruleDTO.shareTitle = shareTitle;
      obj.ruleDTO.shareIntroduce = shareIntroduce;
      obj.ruleDTO.sharePic = sharePic;

      // 2025-11-28 定时开奖新增字段
      if(this.ruleForm.timingPrizeDrawType == 2){
        obj.ruleDTO.timingPrizeTimeList = this.ruleForm.timingPrizeTimeList
      }else{
      // 开奖时间
        obj.ruleDTO.timingPrizeTime = timingPrizeTime;
      }
      obj.ruleDTO.timingPrizeDrawType = this.ruleForm.timingPrizeDrawType == 2 ? 1 : 0
      obj.ruleDTO.taskDisplayType = this.ruleForm.taskDisplayType  
      obj.ruleDTO.taskRewardType = this.ruleForm.taskRewardType   

      // 占位图    
      obj.ruleDTO.isCustomPlaceholderImage = isCustomPlaceholderImage;
      if(isCustomPlaceholderImage==1){
        obj.ruleDTO.customPlaceholderImage = customPlaceholderImage;
      } else {
        obj.ruleDTO.customPlaceholderImage = "";
      }
      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: obj.pointActivityPrizeDTOList.map((item) => {
              const prize = {
                ...item,
                prizeId: item.id,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              return prize;
            }),
            isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
            itemList: this.itemListForFilter,
            activityName: obj.activityName,
            condFollow: obj.condFollow,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          // 进行中修改-只需传新增的任务
          if (params.ruleDto.taskList && params.ruleDto.taskList.length) {
            params.ruleDto.taskList = params.ruleDto.taskList.filter(
              (list) => !list.id
            );
          }
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          if (this.isDraft) {
            obj.status = 5;
          } else {
            // 保存正式活动不需要status
            if (obj.status) {
              delete obj.status;
            }
            if (!this.activityData.isCopy && !this.isDraftEdit) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
              }
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
          }
          timePrizeSave(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getTimePrizeDetail(this.valueRow.id)
          .then((res) => {
            try {
              this.isCreated = true
              const {
                activityName,
                startTime,
                endTime,
                allowLevel,
                condFollow,
                ruleDescription,
                ruleDto,
                pointActivityPrizeDTOList,
                isExposureItem,
                studentSatus,
              } = res.data;
              const {
                unlockPrizeType,
                orderStartTime,
                orderEndTime,
                orderPaymentType,
                filterType,
                filterSkuType,
                itemList,
                orderType,
                countType,
                prizeSettingType,
                taskList,
                needPoint,
                calendarRemindFlag,
                timingPrizeTime,
                timingPrizeType,
                isCheckConsume,
                trialConsumeAmount,
                stepList,
                isAdditionPrize,
                joinNum,
                underJoinNum,
                isPrizeType,
                customerPaperwork,
                firstOpenCardTimeType,
                openCardStartTime,
                openCardEndTime,
                plusObject,
                shareTitle,
                shareIntroduce,
                sharePic,
                isCustomPlaceholderImage,
                customPlaceholderImage,
                openCardBeforeDay,
                openCardFollow,
                sendType,
                timingPrizeDrawType,
                timingPrizeTimeList,
                taskDisplayType,
                taskRewardType,
                sendDay,
                sellerSkuList,
                venderIds,
                skuIdList,
                multiShopSkuType,
                skuBelongVenderId,
                showProductConditon,
                goShopSetting,
                goShopAppId,
                goShopUrl,
                mergeOrder,
              } = ruleDto;
              // 活动名称
              const length = (activityName + "复制").length;
              this.ruleForm.activityName =
                activityName +
                (this.activityData.isCopy && length <= 15 ? "复制" : "");
              // 活动对象
              if (allowLevel == "99") {
                this.peopleSelected = res.data.crowdIds.split(",");
                this.actMember = "3";
              } else if (allowLevel == "-1") {
                this.actMember = "1";
              } else {
                this.actMember = "2";
                if (allowLevel.indexOf("-1") != -1) {
                  this.ruleForm.partner = ["-1"];
                } else {
                  this.ruleForm.partner = allowLevel.split(",");
                }
              }

              // 2025-11-28新增定时开奖字段
              this.ruleForm.timingPrizeDrawType = timingPrizeDrawType ? 2 : 0
              if(timingPrizeDrawType){
                this.ruleForm.timingPrizeTimeList = timingPrizeTimeList
              }else{
                // 开奖时间
                this.ruleForm.timingPrizeTime = timingPrizeTime;
              }
              this.ruleForm.taskDisplayType = taskDisplayType
              this.ruleForm.taskRewardType = taskRewardType

              // 关注
              this.ruleForm.condFollow = Boolean(condFollow);
              // 黑名单
              this.ruleForm.isValidBlackList = res.data.isValidBlackList;
              // 入会时间
              this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
              this.ruleDto.openCardStartTime = openCardStartTime;
              this.ruleDto.openCardEndTime = openCardEndTime;
              if(openCardStartTime&&openCardEndTime){
                this.ruleForm.firstOpenCardTimeType = 2;
              }
              // 入会时间
              this.ruleForm.openCardBeforeDay = openCardBeforeDay||""
              // 关注店铺开卡
              this.ruleForm.openCardFollow = openCardFollow || 0;
              // plus会员
              this.ruleDto.plusObject = plusObject;
              // 学生身份
              this.ruleForm.studentSatus = studentSatus || "";
              // 强提醒
              this.ruleDto.isForceRemind = res.data.ruleDto.isForceRemind;
              // 是否重点活动
              this.isKeyActivity = res.data.isKeyActivity||0;
              // 活动投放位置
              this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
              // 自定义背景图
              this.ruleDto.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON || "";
              // 奖品发放形式
              this.ruleDto.sendType = sendType || 0;
              this.ruleDto.sendDay = sendDay || "";
              // 模板id
              if(res.data.templateId) {
                this.templateId = res.data.templateId
              }
              // 解锁方式
              this.ruleForm.unlockPrizeType = unlockPrizeType;
              if (unlockPrizeType == 1) {
                // 下单时间
                this.ruleForm.orderStartTime = orderStartTime;
                this.ruleForm.orderEndTime = orderEndTime;
                // 金额统计类型
                this.ruleForm.orderPaymentType = orderPaymentType;
                // 订单拆单后是否合并
                this.ruleForm.mergeOrder = mergeOrder||false;

                //商品要求
                this.ruleForm.filterType = filterType;
                // 指定商品规则
                this.ruleForm.filterSkuType = filterSkuType||0;
                // if (filterType == 1) {
                //   this.includeArr = itemList;
                // } else if (filterType == 2) {
                //   this.excludeArr = itemList;
                // }
                this.ruleForm.sellerSkuList = sellerSkuList&&sellerSkuList.length>0 ? sellerSkuList : [{
                  venderId: this.venderId,
                  skuIds: skuIdList||[],
                  itemList: []
                }];
                this.ruleForm.showProductConditon = showProductConditon || false;
                this.ruleForm.venderIds = venderIds&&venderIds.length>0 ? venderIds : [this.venderId];
                if(this.isGray) {
                  this.ruleForm.sellerSkuList = this.ruleForm.sellerSkuList.filter((item)=>item.venderId==this.venderId)
                  this.ruleForm.venderIds = [this.venderId]
                }
                this.multiShopGoods = useValidateMultiShopGoods(this,venderIds);
                // this.filterTypeChange(filterType);
                if (this.activityData.isCopy||this.isDraftEdit) {
                  // 跨店复制
                  if(this.ruleForm.venderIds.length>0) {
                    let index = this.ruleForm.venderIds.findIndex((item)=>{
                      return item == this.venderId
                    })
                    if(index==-1) {
                      this.ruleForm.venderIds.unshift(Number(this.venderId))
                      this.ruleForm.sellerSkuList.unshift({
                        venderId: Number(this.venderId),
                        skuIds: [],
                        itemList: [],
                      })
                    }
                  }
                }
                this.multiShopGoods = useValidateMultiShopGoods(this,this.ruleForm.venderIds);
                // 订单状态
                this.ruleForm.orderType = orderType;
                // 统计逻辑
                this.ruleForm.countType = countType||0;
                // 下单跳转链接
                this.ruleForm.goShopSetting = goShopSetting||0;
                this.ruleForm.goShopAppId = goShopAppId;
                this.ruleForm.goShopUrl = goShopUrl;
              } else if (unlockPrizeType == 2) {
                this.unlockTaskDataList = taskList
                  .filter((item) => item.type == 0)
                  .map((item) => {
                    const obj = { ...item };
                    const itemObj = this.unlockTaskTypeOptions.find(
                      (list) => list.value == item.taskType
                    );
                    if (itemObj && itemObj.taskCondition) {
                      obj.taskCondition = itemObj.taskCondition;
                    }
                    if ([3, 4, 12].includes(item.taskType)) {
                      obj.itemListForFilter = item.itemList
                        ? item.itemList
                        : [];
                      if ([3, 12].includes(item.taskType)) {
                        obj.taskCondition = item.viewCartLimit;
                      } else {
                        // 加购商品
                        obj.taskCondition = item.addCartLimit;
                      }
                    }
                    if (item.taskType == 17) {
                      obj.selectGoodsFilterArr = item.itemList
                        ? item.itemList
                        : [];
                      obj.itemStartCount = item.itemTotalLimit;
                      obj.orderStartPayment = item.amtLimit;
                      obj.venderIds = obj.venderIds ? obj.venderIds.split(",").map((item)=>+item) : [this.venderId]
                      obj.sellerSkuList = obj.sellerSkuList&&obj.sellerSkuList.length>0 ? obj.sellerSkuList : [{
                        skuIds: item.skuIds,
                        venderId: this.venderId
                      }]
                      if (this.activityData.isCopy||this.isDraftEdit) {
                        // 跨店复制
                        if(obj.venderIds.length>0) {
                          let index = obj.venderIds.findIndex((item)=>{
                            return item == this.venderId
                          })
                          if(index==-1) {
                            obj.venderIds.unshift(Number(this.venderId))
                            obj.sellerSkuList.unshift({
                              venderId: Number(this.venderId),
                              skuIds: []
                            })
                          }
                        }
                      }
                      if(this.isGray) {
                        obj.sellerSkuList = obj.sellerSkuList.filter((item)=>item.venderId == this.venderId)
                        obj.venderIds = [this.venderId]
                      }
                      obj.orderPaymentType = item.orderPaymentType===null ? 1 : item.orderPaymentType;
                      obj.mergeOrder = item.mergeOrder || false;
                    }
                    return obj;
                  });
              } else if (unlockPrizeType == 3) {
                this.ruleForm.needPoint = needPoint;
              }

              // 日历提醒
              this.ruleForm.calendarRemindFlag = calendarRemindFlag;

              // 增加中奖概率任务
              if (taskList && taskList.length) {
                this.taskDataList = taskList
                  .filter((item) => item.type == 1)
                  .map((item) => {
                    const itemObj = this.taskTypeOptions.find(
                      (list) => list.value == item.taskType
                    );
                    const obj = { ...item };
                    if (itemObj && itemObj.taskCondition) {
                      obj.taskCondition = itemObj.taskCondition;
                    }
                    if ([3, 4, 9, 12].includes(item.taskType)) {
                      obj.itemListForFilter = item.itemList
                        ? item.itemList
                        : [];
                    }
                    // 任务条件
                    if ([3, 4, 9, 10, 11, 12].includes(item.taskType)) {
                      if (item.taskType == 4) {
                        // 加购商品
                        obj.taskCondition = item.addCartLimit;
                      } else {
                        obj.taskCondition = item.viewCartLimit;
                      }
                    }
                    // 积分兑换
                    if (item.taskType == 16) {
                      obj.taskCondition = item.viewCartLimit;
                      obj.finishLimit = item.taskDoLimit;
                    }
                    // 邀请好友入会
                    if (item.taskType == 18) {
                      obj.inviteLimit = item.inviteLimit;
                    }
                    if (item.taskType == 17) {
                      obj.selectGoodsFilterArr = item.itemList
                        ? item.itemList
                        : [];
                      obj.itemStartCount = item.itemTotalLimit;
                      obj.orderStartPayment = item.amtLimit;
                      obj.venderIds = obj.venderIds ? obj.venderIds.split(",").map((item)=>+item) : [this.venderId]
                      obj.sellerSkuList = obj.sellerSkuList&&obj.sellerSkuList.length>0 ? obj.sellerSkuList : [{
                        skuIds: item.skuIds,
                        venderId: this.venderId
                      }]
                      if(this.isGray) {
                        obj.sellerSkuList = obj.sellerSkuList.filter((item)=>item.venderId == this.venderId)
                        obj.venderIds = [this.venderId]
                      }
                      if (this.activityData.isCopy||this.isDraftEdit) {
                      // 跨店复制
                      if(obj.venderIds.length>0) {
                        let index = obj.venderIds.findIndex((item)=>{
                          return item == this.venderId
                        })
                        if(index==-1) {
                          obj.venderIds.unshift(Number(this.venderId))
                          obj.sellerSkuList.unshift({
                            venderId: Number(this.venderId),
                            skuIds: [],
                          })
                        }
                      }
                      obj.orderPaymentType = item.orderPaymentType===null ? 1 : item.orderPaymentType;
                      obj.mergeOrder = item.mergeOrder || false;
                    }
                    }
                    if(item.taskType == 5) {
                      obj.viewTime = item.viewTime || 1;
                      obj.giveLimit = item.giveLimit || 1;
                    }
                    if(item.taskType == 23) {
                      obj.searchKeyword = item.searchKeyword;
                    }
                    return obj;
                  });
              }
              // 开奖方式
              this.ruleForm.timingPrizeType = timingPrizeType;
              // 中奖条件
              this.ruleForm.isCheckConsume = isCheckConsume || 0;
              this.ruleForm.trialConsumeAmount = trialConsumeAmount;

              if (timingPrizeType == 3) {
                this.ruleForm.joinNum = joinNum;
                this.ruleForm.underJoinNum = underJoinNum;
                this.ruleForm.isPrizeType = isPrizeType;
              }

              // 曝光商品
              this.ruleForm.exposureSwitch = isExposureItem ? true : false;
              if (this.ruleForm.exposureSwitch) {
                this.itemListForFilter = res.data.itemList;
                this.mainImagelist = res.data.itemList;
                this.selectGoodsFilterArr = res.data.itemList;
              }
              this.multiShopSkuType = multiShopSkuType || 0;
              this.skuBelongVenderId = skuBelongVenderId || "";

              // 占位图 
              this.ruleForm.isCustomPlaceholderImage = isCustomPlaceholderImage;
              this.ruleForm.customPlaceholderImage = customPlaceholderImage;

              // 活动页设置
              const activitySetting = JSON.parse(customerPaperwork);
              this.customerPaperwork = activitySetting;
              this.ruleForm.activityTheme = activitySetting.activityTheme;
              this.ruleForm.activityRemark = activitySetting.activityRemark;
              this.ruleForm.textColor = activitySetting.textColor;
              this.ruleForm.showWinList = activitySetting.showWinList;
              this.ruleForm.showJoinList = activitySetting.showJoinList;
              this.ruleForm.templateType = activitySetting.templateType ? activitySetting.templateType : 1;
              this.ruleForm.shopNameType = activitySetting.shopNameType || 0;
              // this.ruleForm.moreActSet = activitySetting.moreActSet || {
              //   isShowFloatWindow: 0,//是否显示活动浮窗：0-不显示，1-显示
              //   floatWindowImg: "",//活动浮窗图片
              //   goShopSetting: 0,//活动浮窗跳转设置
              //   goShopAppId: "",//活动浮窗跳转小程序ID
              //   goShopUrl: "",//活动浮窗跳转链接
              //   isShowBanner: 0,//是否显示活动banner：0-不显示，1-显示
              //   bannerList: [],//banner列表
              // };
              this.hdTaskTemplateGroup();
              this.getNewPolite()
              if(!('bgColor' in this.customerPaperwork)) {
                this.customerPaperwork.bgColor = "#000000";

              }
              if(!('bgOpacity' in this.customerPaperwork)) {
                this.customerPaperwork.bgOpacity = 50
              }
              if(!('prizeNameColor' in this.customerPaperwork)) {
                this.$set(this.customerPaperwork, 'prizeNameColor', this.ruleForm.templateType==1 ? "#1A1A1A" : "#FFFFFF");
              }
              // 分享设置回显
              this.ruleForm.shareTitle = shareTitle;
              this.ruleForm.shareIntroduce = shareIntroduce;
              this.ruleForm.sharePic = sharePic;

              if (!this.activityData.isCopy) {
                // 活动时间
                this.ruleForm.startTime = startTime;
                this.ruleForm.endTime = endTime;
                // 奖品池设置
                this.ruleForm.prizeSettingType = prizeSettingType;

                if (prizeSettingType == 0) {
                  // 奖品设置
                  const prizeList = pointActivityPrizeDTOList.filter(
                    (item) => item.prizeObjectType != 1
                  );
                  if (prizeList && prizeList.length) {
                    this.prizeSettingList = prizeList.map((item, index) => {
                      const prizeItem = {
                        ...item,
                        index,
                      };
                      // 提交地址限制回显：逗号分隔字符串转数字数组
                      if (item.prizeType == 3) {
                        if (item.commitAddressLimit) {
                          prizeItem.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                            ? item.commitAddressLimit.split(',').map(Number)
                            : item.commitAddressLimit;
                        } else {
                          prizeItem.commitAddressLimit = [0];
                        }
                      }
                      return prizeItem;
                    });
                  }
                  if (unlockPrizeType == 1) {
                    const stepItem = stepList[0];
                    this.ruleForm.itemStartCount = stepItem.itemLimitCount;
                    this.ruleForm.orderStartPayment =
                      stepItem.orderPaymentLimit;
                  }
                } else {
                  this.prizeSettingListStep = stepList.map((item) => {
                    const itemObj = {
                      itemStartCount: item.itemLimitCount,
                      orderStartPayment: item.orderPaymentLimit,
                      table: pointActivityPrizeDTOList.filter(
                        (list) => list.taskIndex == item.taskIndex
                      ).map(list => {
                        // 提交地址限制回显：逗号分隔字符串转数字数组
                        if (list.prizeType == 3) {
                          if (list.commitAddressLimit) {
                            list.commitAddressLimit = typeof list.commitAddressLimit === 'string'
                              ? list.commitAddressLimit.split(',').map(Number)
                              : list.commitAddressLimit;
                          } else {
                            list.commitAddressLimit = [0];
                          }
                        }
                        return list;
                      }),
                    };
                    if (!itemObj.table.length) {
                      itemObj.table = {
                        index: 0,
                        prizeType: null,
                        price: null,
                        logo: null,
                        title: "",
                        totalAmount: null,
                      };
                    }
                    return itemObj;
                  });
                }
                this.ruleForm.isAdditionPrize = isAdditionPrize;
                if (isAdditionPrize) {
                  const otherPrize = pointActivityPrizeDTOList.filter(
                    (list) => list.prizeObjectType == 1
                  );
                  if (otherPrize && otherPrize.length) {
                    this.prizeSettingListOther = otherPrize.map(list => {
                      // 提交地址限制回显：逗号分隔字符串转数字数组
                      if (list.prizeType == 3) {
                        if (list.commitAddressLimit) {
                          list.commitAddressLimit = typeof list.commitAddressLimit === 'string'
                            ? list.commitAddressLimit.split(',').map(Number)
                            : list.commitAddressLimit;
                        } else {
                          list.commitAddressLimit = [0];
                        }
                      }
                      return list;
                    });
                  }
                }
                this.ruleForm.ruleDescription = ruleDescription;
              } else {
                this.ruleForm.timingPrizeTime = "";
                this.ruleForm.timingPrizeTimeList = ["", ""];
              }
              this.activityTimeChange();
            } catch (e) {
              console.lolg(e);
            }
          })
          .catch((res) => {});
      } else {
        this.hdTaskTemplateGroup();
      }
    },
    // 初始化时间
    setTime() {
      this.ruleForm.startTime = this.$getDate(30)[0];
      // 判断当前时间是否大于软件有效期
      const endTime = this.$getDate(30)[1];
      const endTimeValue = new Date(endTime).valueOf();
      const expiresIn = this.$store.getters.loginUserInfo.expiresIn;
      let expiresInValue = new Date(expiresIn).valueOf();
      if (endTimeValue > expiresInValue) {
        this.ruleForm.endTime = expiresIn;
      } else {
        this.ruleForm.endTime = endTime;
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
    },
    // 清空下单时间
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    // 活动时间改变
    activityTimeChange() {
      // 校验有无时间
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let CRMtime = new Date(this.jdCrm.endTime).valueOf();
      // 店铺接入有效期
      let platformInvalidateDate =
        this.$store.getters.loginUserInfo.platformInvalidateDate;
      // 店铺接入有效期
      if (this.softType == 1) { // 京获客旗舰版
        platformInvalidateDate = this.$store.getters.loginUserInfo.invalidateDate;
      }
      const hdInvalidateDate =
        this.$store.getters.loginUserInfo.hdInvalidateDate;
      let platformInvalidateDateValue = new Date(
        platformInvalidateDate
      ).valueOf();
      // 互动数据授权
      let hdInvalidateDateValue = new Date(hdInvalidateDate).valueOf();
      var date3;
      const platformInvalidateDateStr = platformInvalidateDate
        ? platformInvalidateDate.split(" ")[0]
        : "";
      const hdInvalidateDateStr = hdInvalidateDate
        ? hdInvalidateDate.split(" ")[0]
        : "";
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end < nowTime) {
        this.$message.warning("活动结束时间不能小于当前时间！");
      }
      if (end < start) {
        this.$message.warning("活动开始时间不能大于结束时间！");
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.ruleForm.endTime = "";
        return;
      }
      if (end > platformInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过店铺接入有效期${platformInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
      if (end > hdInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过互动数据授权有效期${hdInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
    },
    //添加指定商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.selectGoodsArr.length == 0) {
        this.selectGoodsArr = [];
        this.selectGoodsArr = [];
      }
      if (this.ruleForm.filterType == 1) {
        this.selectGoodsArr = this.includeArr;
      } else if (this.ruleForm.filterType == 2) {
        this.selectGoodsArr = this.excludeArr;
      }
      this.$nextTick(() => {
        this.$refs.selectGo.handleRightCurrentChange(1);
      });
    },

    selectGoodsClose(data) {
      if (data) {
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        if (this.ruleForm.filterType == 1) {
          this.includeArr = selectGoodsArr;
        } else if (this.ruleForm.filterType == 2) {
          this.excludeArr = selectGoodsArr;
        }
        this.selectGoodsArr = selectGoodsArr;
      }
      this.selectGoodsState = false;
    },
    // 是否自营
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          var data1 = new Date(res.message);
          var data2 = new Date();
          this.jdCrm.endTime = res.message;
          if (data1.getTime() > data2.getTime()) {
            this.jdCrm.isCrm = true;
          } else {
            this.jdCrm.isCrm = false;
          }
        }
      });
    },
    toCreated(uitype, templateId = 0) {
      if (sessionStorage.getItem("venderType") == 0) {
        this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateJson.templateUItype = uitype;
      // 新增活动-初始化活动时间
      if (!this.valueRow && this.isFirstTime) {
        this.isFirstTime = false;
        this.setTime();
        this.activityTimeChange();
        // 默认开奖时间为活动结束时间的前的48小时
        if (this.ruleForm.endTime) {
          this.ruleForm.timingPrizeTime = this.moment(
            new Date(this.ruleForm.endTime).valueOf() - 48 * 60 * 60 * 1000
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    },
    toCreated1(uitype, templateId = 0) {
      this.localStepNum = 0;
      this.templateJson.templateUItype = uitype;
      if (templateId) {
        this.templateId = templateId;
      }
    },
    toCRM() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.ruleForm.exposureSwitch = false;
      this.selectGoodsStateFilter = false;
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 重置颜色
    resetColor() {
      this.ruleForm.textColor = defaultTextColor;
    },
    // 新增任务
    addUnlockTask() {
      this.isUnlockTaskEdit = false;
      this.unlockTaskDialog = true;
    },
    getUnlockTaskDataList(selectList) {
      console.log(selectList);
      this.unlockTaskDataList = selectList;
      this.unlockTaskDialog = false;
    },
    // 修改任务
    editUnlockTask(row, $index) {
      console.log(row, $index);
      this.currentIndex = $index;
      const copyRow = JSON.parse(JSON.stringify(row));
      this.isUnlockTaskEdit = true;
      this.unlockTaskForm = copyRow;
      this.unlockTaskDialog = true;
    },
    // 删除任务
    deleteUnlockTask($index) {
      this.unlockTaskDataList.splice($index, 1);
    },
    // 添加任务
    addTask() {
      this.isTaskEdit = false;
      this.taskDialog = true;
    },
    getTaskDataList(selectList) {
      console.log(selectList);
      this.taskDataList = selectList;
      this.taskDialog = false;
    },
    closeTask() {
      this.taskDialog = false;
    },
    // 修改任务
    editTask(row, $index) {
      console.log(row, $index);
      this.currentIndex = $index;
      const copyRow = JSON.parse(JSON.stringify(row));
      this.isTaskEdit = true;
      this.taskForm = copyRow;
      this.taskDialog = true;
    },
    // 删除任务
    deleteTask($index) {
      this.taskDataList.splice($index, 1);
    },
    // 下单时间
    orderEndTimeChange() {
      // 开奖时间
      if (this.ruleForm.timingPrizeTime) {
        if (
          this.isSameDay(
            this.ruleForm.timingPrizeTime,
            this.ruleForm.orderEndTime
          ) &&
          new Date(this.ruleForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.timingPrizeTime).valueOf()
        ) {
          this.ruleForm.orderEndTime = this.ruleForm.timingPrizeTime;
        }
        return;
      }
      if (this.ruleForm.endTime) {
        if (
          this.isSameDay(this.ruleForm.endTime, this.ruleForm.orderEndTime) &&
          new Date(this.ruleForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.ruleForm.orderEndTime = this.ruleForm.endTime;
        }
      }
    },
    timingPrizeTimeChange() {
      if (this.ruleForm.endTime) {
        const actEndTime48 =
          new Date(this.ruleForm.endTime).valueOf() - 48 * 60 * 60 * 1000;
        if (
          this.isSameDay(actEndTime48, this.ruleForm.timingPrizeTime) &&
          new Date(this.ruleForm.timingPrizeTime).valueOf() >
            new Date(actEndTime48).valueOf()
        ) {
          this.ruleForm.timingPrizeTime = this.getAllTime(actEndTime48);
        }
      }
    },
    // 判断是否同一天
    isSameDay(date1, date2) {
      // 将日期转换为Date对象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 设置时间为午夜12点（这样可以忽略时分秒）
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);

      // 比较年月日是否相同
      return d1.getTime() === d2.getTime();
    },
    // 获取时间
    getAllTime(date) {
      const time = new Date(date);
      let yy = time.getFullYear(); //当前年份
      let mm =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      let dd = time.getDate() < 10 ? "0" + time.getDate() : time.getDate(); //当前天数
      return `${yy}-${mm}-${dd} ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
    },
    // 添加奖项
    addSetting() {
      let length = this.prizeSettingList.length;
      if (length > 10) {
        return this.$message.warning("最多设置11个奖品");
      }
      this.prizeSettingList.push({
        index: 0,
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
      });
    },
    // 添加阶梯
    addStep() {
      let length = this.prizeSettingListStep.length;
      if (length > 4) {
        return this.$message.warning("最多设置5个阶梯奖品池");
      }
      this.prizeSettingListStep.push({
        orderStartPayment: null,
        itemStartCount: null,
        table: [
          {
            index: 0,
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
          },
        ],
      });
    },
    addSettingStep(arr) {
      console.log(arr);
      let length = arr.length;
      if (length > 10) {
        return this.$message.warning("最多设置11个奖品");
      }
      arr.push({
        index: 0,
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
      });
    },
    deleteStep(index) {
      this.prizeSettingListStep.splice(index, 1);
    },
    // 上移
    up(arr, index) {
      arr[index] = arr.splice(index - 1, 1, arr[index])[0];
    },
    // 下移
    down(arr, index) {
      arr[index] = arr.splice(index + 1, 1, arr[index])[0];
    },
    // 删除奖品
    del(arr, $index) {
      arr.splice($index, 1);
    },
    // 解锁方式change
    unlockPrizeTypeChange(e) {
      if (e != 1) {
        this.ruleForm.prizeSettingType = 0;
        // 切换其他解锁方式时，奖品发放形式默认切换为"立即发放"
        this.ruleDto.sendType = 0;
      }
    },
    // 附加奖品删除
    itemDelAdditional() {
      this.prizeSettingListOther = [
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}
.rule_box {
  width: 860px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-top: 0px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 0px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 0px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
  .support {
    display: flex;
    align-items: center;
    &-text {
      margin: 0px 8px;
    }
    &-icon {
      color: #ccc;
      cursor: pointer;
    }
  }
}

.input-w425 {
  width: 425px;
}

.label {
  &-right {
    margin-right: 8px;
  }
  &-left {
    margin-left: 8px;
  }
}

.el-icon-question {
  color: #ccc;
  cursor: pointer;
}

.flex-center {
  display: flex;
  align-items: center;
}

.el-textarea {
  /deep/ .el-input__count {
    padding: 0px 5px;
    line-height: normal;
  }
}

.active-tip {
  color: #f89f39;
}

.prize_box {
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  &_middle {
    padding-top: 10px;
  }
  &_step {
    margin-top: 16px;
    border: 1px solid #f0f0f0;
    &_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4px 10px;
      background-color: #fafafa;
      &__delete {
        cursor: pointer;
      }
    }
    &_center {
      background-color: #fff;
      padding: 10px 0px;
    }
    &_margin {
      margin-bottom: 0px !important;
    }
  }
}
.condition-box {
  margin: 12px 0;
  width: fit-content;
  padding: 16px;
  background: #f4f6fa;
  border-radius: 4px;
}

.w100 {
  width: 100px;
}

.mlr8 {
  margin: 0px 8px;
}
.upload-box {
  width: 450px;
  padding: 20px 20px 1px;
  background: #f4f6fa;
  border-radius: 4px;
}
.w200 {
  width: 200px;
}
</style>
<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
